import { createService } from "./service.js"
import { AppHelper } from "../appHelper.js"
import { FullHeightContainer } from "../core/components/FullHeighContainer.js";
import { MouseButton, Menu, MenuEntry, EntryType } from "../core/components/menu.js";
import { DropDownList } from "../core/components/dropDownList.js";
import { DatePicker } from "../core/components/datePicker.js";
import { DateTimePicker } from "../core/components/dateTimePicker.js";
import { IsSearchField } from "../core/components/isSearchField.js";
import { PageTitle } from "../core/components/pageTitle.js";
import { TextBox } from "../core/components/textBox.js";
import { MultiSelect } from "../core/components/multiSelect.js";
import { CheckBox } from "../core/components/checkBox.js";
import { RightDrawerContainer } from "../core/components/rightDrawerContainer.js";
import { AppMetadata, Helper } from "../core/util/helper.js";
import { General } from "../../siteManagement/general.js";
import { SheetEventType, Sheet } from "../../siteManagement/sheet.js";
import { NotificationHelper } from "../core/util/notificationHelper.js";
import TitleText from "../core/components/titleText.js";
import { DynamicSearchContextHook, getInternalSearchContextApps } from "./hooks.js";
import { Config } from "../core/config/config.js";
import { EntityReminders } from "../reminders/reminders.js";
import { BookmarkBtn } from "../bookmark/bookmarkBtn.js";
import { EventType } from "../../siteManagement/eventManager.js";
import { ComponentHelper } from "../core/util/componentHelper.js";
import { CancelTokenSource } from "axios";
import { MappingService } from "./mappingService.js";
import SearchTemplates, { InitialSearchTemplate, SearchFilterControl, SearchTemplatesHelper } from "./searchTemplates.js";
import { BaseComponentProps } from "../core/components/baseComponentProps.js";
import { Entity, Metadata } from "../core/components/commonApp.js";
import { StringKeyDictionary } from "../commonInterfaces.js";
import { RequirementProfile } from "./requirementProfile.js";
import React from "react"
import ReactDOM from "react-dom";
import axios from "axios";
import {HTTPService} from "../core/util/httpManager";
export class DynamicSearchApp extends React.Component<DynamicSearchAppProps, {
    inititalSearchTemplate: InitialSearchTemplate;
}> {
    private _id = kendo.guid();
    private _gridElementRef = null;
    private _gridRef: kendo.ui.Grid = null;
    private _gridOptions: kendo.ui.GridOptions = null;
    private _dataItem = null;
    private _multiSelectItems: Array<SelectedItemData> = [];
    private _gridDataSource: kendo.data.DataSource = null;
    private _editUrlStem: string = null;
    private _newUrl: string = null;
    private _isoFullRegEx: RegExp = /^\d{4}-\d\d-\d\dT\d\d:\d\d:\d\d(\.\d+)?(([+-]\d\d:\d\d)|Z)?$/i;
    private _freeTextSearch = "_freeTextSearch";
    private _cancelDataRequest = true;
    private _rowOptionsText = "";
    private _gridKey = "";
    //end grid
    //menu
    private _menuDataSource: Array<MenuEntry> = [];
    private _menuRef: Menu = null;
    private _menuButtonsData: StringKeyDictionary<DynamicSearchMenuButton> = {};
    private _contextMenuButtons: StringKeyDictionary<DynamicSearchMenuButton> = {};
    private _customButtons: Array<string> = [];
    //end menu
    //accordion
    private _quickSearchInputRef: QuickSearchInput = null;
    private _quickSearchState = {
        value: null,
        sent: false, //not used
        timeoutHandle: null
    };
    private _accordionOpen = false;
    private _searchComponents: StringKeyDictionary<SearchFilterControl> = {};
    private _useInitialSearchValues = false;
    private _dataSources: StringKeyDictionary<Array<any>> = {};
    private _leftDrawerElement: JQuery = null;
    private _filterContainerRef: SearchFilters = null;
    private _disabledFilters: string[] = [];
    //end accordion
    //search templates
    private _searchTemplatesRef: SearchTemplates = null;
    //end templates
    //multiselect summary
    private _multiSelectSummaryRef: MultiSelectSummary = null;
    private _applyTriggered = false;
    //end multiselect summary
    //skills
    private _requirementProfile: RequirementProfile = null;
    //end skills
    private _service = createService();
    private _columnsHash: StringKeyDictionary<DynamicSearchColumnInfo> = {};
    //private _modalContainer: WindowSheetContainerProps = null; // kendo.ui.Window = null;
    private _sheetContainer: Sheet = null;
    private _verticalTabStripWrapper: JQuery = null;
    //command hooks
    private _contextHooks: Array<DynamicSearchContextHook> = [];
    //other
    private _customHtml: HTMLElement = null;
    private _stateIndex = -1;
    //set in JSON
    private _browserTitle: string = null;
    //set in JSON
    private _pageTitle: string = null;
    isWindow = false;
    openSheet = false;

    common = new AppHelper();
    dynamicSearchCallbacks: DynamicSearchCallbacks = {
        onRequestStart: () => { },
        onRequestEnd: () => { },
        onRequestError: () => { },
        onAdditionalData: () => { return {}; },
        onRowSelected: (dataItem) => { },
        onMultiRowsSelected: (dataItems) => { },
        onLinkClicked: (dataItem: any, $row: JQuery, $link: JQuery, ev: JQuery.Event) => { },
        onCustomButtonClick: (btnName, dataItem) => { },
        onGridDataBound: (dataItems: Array<any>) => { }
    };
    options = {
        pageSize: 100,
        initialFilterState: InitialSearchFilterState.QuickSearch
    };

    private _addItemToMultislect: boolean = true;
    private _openActionDisabled: boolean = false;

    constructor(props) {
        super(props);
        this.state = {
            inititalSearchTemplate: {
                initialTemplate: null,
                merge: false
            }
        }
        this.common.init(this);
        this.common.enableHooks = true;
        if (props.metadata) {
            const metadata: AppMetadata = props.metadata;
            this._browserTitle = metadata.browserTitle;
            this._pageTitle = metadata.pageTitle;
        }
        this._initApp();
        if (!Helper.useMobileGui())
            General.Drawer.Left.open();
        General.Drawer.Left.setSaveState(false);
    }
    ////////// M E N U //////////

    //initializes the menu data source

    private _initMenu = () => {
        //process all the buttons
        for (let i = 0; i < this.props.config.MenuButtons.length; i++) {
            const mb = this.props.config.MenuButtons[i];
            const btn: MenuEntry = {
                text: mb.Text,
                onClick: mb.Name,
                show: true,
                inContext: true
            };
            if (this.props.config.MenuButtons[i].Name == "new") {
                this.props.config.MenuButtons[i].Url = this._newUrl;
                btn.floating = true;
                btn.type = EntryType.New;
            } else if (this.props.config.MenuButtons[i].Name == "select") {
                btn.floating = true;
                btn.icon = "check";
                btn.type = EntryType.LikeSave;
            }

            this._menuButtonsData[mb.Name] = mb;

            if (mb.Type !== MenuItemType.Command && mb.Type !== MenuItemType.Link && mb.Name !== "search") {
                this._menuDataSource.push(btn);
            }

            if (mb.Type === MenuItemType.Command || mb.Type === MenuItemType.Link) {
                this._contextMenuButtons[mb.Name] = mb;
            }
        }
    }

    //called when a menu button is pressed
    private _doOnMenuSelect = (name: string, mouseButton: MouseButton) => {
        if (this._menuButtonsData[name]) {
            if (Helper.hasValue(this._menuButtonsData[name].Url)) {
                //hanlde URL "action"
                this._handleUrlButton(this._menuButtonsData[name], mouseButton);
            } else {
                //check for a "standard", non-configurable button
                switch (name.toLowerCase()) {
                    case "search":
                        this._triggerSearch();
                        break;
                    case "exportcurrent":
                        this._exportCurrentPage();
                        break;
                    case "exportall":
                        this._exportAll();
                        break;
                    case "exportallnolimit":
                        this._exportAllNoLimit();
                        break;
                    case "selectcurrent":
                        this._handleBatchDataSelect(true);
                        break;
                    case "selectall":
                        this._handleBatchDataSelect(false);
                        break;
                    case "clearall":
                        this._clearAllMultiSelectItems();
                        break;
                    case "select":
                        this._applySelection();
                        break;
                    case "back":
                        history.back();
                        break;
                    case "close":
                        this._sheetContainer.hide();
                        break;
                    default:
                        //no known action detected, treat as custom action
                        this.dynamicSearchCallbacks.onCustomButtonClick(name, this.props.config.IsMultiSelect ? this._multiSelectItems.map(x => x.item) : this._dataItem);
                        break;
                }
            }
        }
    }

    //build the URL and open the new page
    private _handleUrlButton = (btn: DynamicSearchMenuButton, mouseButton: MouseButton, dataItem?: null) => {
        let tmpUrl = btn.Url;
        //dataItem is used for context options
        const currentDataItem = dataItem || this._dataItem;

        if (Helper.hasValue(currentDataItem)) {
            //placeholder
            if (tmpUrl.indexOf("{{{") !== -1) {
                tmpUrl = Helper.processCustomTemplate(tmpUrl, "{{{", "}}}", (match) => {
                    let value = null;
                    if (match === "primarykey") {
                        value = currentDataItem[btn.Data.primaryKey];
                    } else if (match === "additionalkey") {
                        value = currentDataItem[btn.Data.additionalKey];
                    } else {
                        value = currentDataItem[btn.Data[match]];
                    }

                    return value;
                });
            } else {
                if (btn.Name !== "new") {
                    //the url should have the key already set (ex: address/edit?id=)
                    tmpUrl += encodeURIComponent(currentDataItem[this.props.config.WindowLinkElements[0]]);
                }
            }
        }

        //Es öffnet nun nur in einen neuem Sheet
        if (tmpUrl.indexOf(this._editUrlStem) !== -1 || tmpUrl.indexOf(this._newUrl) !== -1 || btn.OpenInSheet) {
            this._openInNewSheet(tmpUrl);
        } else {
            window.location.href = tmpUrl;
        }
    }

    //enabled conditions for the menu buttons
    private _enableMenuItem = (name: string | boolean) => {
        if (typeof name === "boolean") {
            return name;
        } else {
            switch (name.toLowerCase()) {
                case "cockpit":
                    return Helper.hasValue(this._dataItem);
                case "edit":
                    return Helper.hasValue(this._dataItem);
                case "back":
                    return !this.isWindow && (history.length > 1);
                case "close":
                    return this.isWindow;
                case "export":
                case "exportcurrent":
                case "exportall":
                case "exportallnolimit":
                case "select":
                case "selectcurrent":
                case "selectall":
                case "clearall":
                case "selectmenu":
                case "new":
                    return true;
            }
            return this.props.config.IsMultiSelect ? this._multiSelectItems.length > 0 : Helper.hasValue(this._dataItem);
        }
    }

    //callback for the context menu
    //if the button is an URL button, it calls _handleUrlButton
    //if the button is a command, tries to call the Search Context App
    private _handleContextButtonClick = (name: string, mouseButton: MouseButton, dataItem: any) => {
        const btn = this._menuButtonsData[name];
        /*only left button for now...*/
        if (btn && mouseButton === MouseButton.Left) {
            if (btn.Type === MenuItemType.Link) {
                this._handleUrlButton(btn, mouseButton, dataItem);
            } else if (btn.Type === MenuItemType.Command) {
                this._contextHooks.forEach(hook => {
                    hook.onCommandClick(name, this._dataItem, {
                        reloadData: () => {
                            this._gridDataSource.read();
                        }
                    });
                });
            }
        }
    }

    ////////// E N D   M E N U //////////


    ////////// A C C O R D I O N //////////

    //handle search type switch (quick search <-> advanced search)
    private _onSearchTypeChanged = (isAdvanced: boolean) => {
        if (isAdvanced) {
            const triggerSearch = Helper.hasValue(this._quickSearchState.value) && this._quickSearchState.value !== "";
            //delete quick search value when closing
            if (triggerSearch) {
                this._searchComponents[this._freeTextSearch].value = this._quickSearchState.value;
            }

            this._quickSearchState.value = null;

            if (!this.isWindow) {
                this._updateUrl(true, true);
            }
        } else {
            let triggerSearch = false;
            const filterData = this._filterDataProvider();
            for (let key in filterData) {
                if (Helper.hasValue(filterData[key]) && filterData[key] !== "") {
                    triggerSearch = true;
                    break;
                }
            }
            if (Helper.hasValue(this._searchComponents[this._freeTextSearch].value)) {
                this._quickSearchState.value = this._searchComponents[this._freeTextSearch].value;
            }
            this._clearSearchComponents();
            this._searchTemplatesRef.resetTemplateNameSelect();
            this._filterContainerRef.setState({}, () => {
                if (!this.isWindow) {
                    this._updateUrl(true, true);
                }
                if (triggerSearch) {
                    this.cancelDataFetch();
                    this._gridDataSource.page(1);
                }
            });
        }

        //update the quick search input with the current value
        this._quickSearchInputRef.setState({
            value: this._quickSearchState.value || "",
            disabled: isAdvanced
        });

        this._accordionOpen = isAdvanced;
        this._menuRef.setState({});
        this._filterContainerRef.setState({
        });
    }


    private _setSearchTemplatesRef = (ref: SearchTemplates) => {
        this._searchTemplatesRef = ref;
    }

    //initializes the filter controls
    private _initSearchFilterControls = () => {
        this.props.config.SearchControls.forEach((searchControl) => {
            //build the hash for fast/easy access
            this._searchComponents[searchControl.ReferenceColumn] = {
                value: "",
                control: searchControl,
                rangeEndValue: "",
                comparativeOperator: searchControl.Comparative as any

            };
            if ((!Helper.isNullOrEmpty(this.props.queryParameters[`${searchControl.ReferenceColumn}_comparative`])) && (searchControl.Type == SearchControlType.Text || searchControl.Type == SearchControlType.SearchField)) {
                switch (this.props.queryParameters[`${searchControl.ReferenceColumn}_comparative`].toLowerCase()) {
                    case "like":
                        this._searchComponents[searchControl.ReferenceColumn].comparativeOperator = 0;
                        break;
                    case "startswith":
                        this._searchComponents[searchControl.ReferenceColumn].comparativeOperator = 6;
                        break;
                    case "endswith":
                        this._searchComponents[searchControl.ReferenceColumn].comparativeOperator = 7;
                        break;
                    case "equalto":
                        this._searchComponents[searchControl.ReferenceColumn].comparativeOperator = 8;
                        break;
                }
            }


            //set the value if it is specified in the URL
            if (Helper.hasValue(this.props.queryParameters)) {
                if (Helper.hasValue(this.props.queryParameters[searchControl.ReferenceColumn])) {
                    this._useInitialSearchValues = true;
                    this._searchComponents[searchControl.ReferenceColumn].value = this.props.queryParameters[searchControl.ReferenceColumn];
                    if (searchControl.Type === SearchControlType.MultiSelect) {
                        this._searchComponents[searchControl.ReferenceColumn].value = this._searchComponents[searchControl.ReferenceColumn].value.split('||')
                        //if there's only one value selected, the server returns it as a single value
                        if (!Array.isArray(this._searchComponents[searchControl.ReferenceColumn].value)) {
                            //convert the value into an array with one element
                            this._searchComponents[searchControl.ReferenceColumn].value = [this._searchComponents[searchControl.ReferenceColumn].value];
                        }
                    } else if (searchControl.Type === SearchControlType.SearchField && searchControl.MultiSelectMode) {
                        this._searchComponents[searchControl.ReferenceColumn].value = this._searchComponents[searchControl.ReferenceColumn].value.split('||').map(x => ({ value: x, text: x }));
                    }
                } else {
                    if (Helper.hasValue(this.props.queryParameters[`${searchControl.ReferenceColumn}_start`])) {
                        this._useInitialSearchValues = true;
                        this._searchComponents[searchControl.ReferenceColumn].value = this.props.queryParameters[`${searchControl.ReferenceColumn}_start`];
                    }
                    if (Helper.hasValue(this.props.queryParameters[`${searchControl.ReferenceColumn}_end`])) {
                        this._useInitialSearchValues = true;
                        this._searchComponents[searchControl.ReferenceColumn].rangeEndValue = this.props.queryParameters[`${searchControl.ReferenceColumn}_end`];
                    }
                }
            }
            //default Values
            if (Helper.isNullOrEmpty(this._searchComponents[searchControl.ReferenceColumn].value.toString()) && Helper.hasValue(searchControl.Default)) {
                let type: SearchControlType = searchControl.Type as SearchControlType;
                let regEx: RegExp = null;
                switch (type) {
                    case SearchControlType.Text:
                    case SearchControlType.CheckBox:
                    case SearchControlType.DropDown:
                        this._searchComponents[searchControl.ReferenceColumn].value = searchControl.Default;
                        this._useInitialSearchValues = true;
                        break;
                    case SearchControlType.MultiSelect:
                        this._searchComponents[searchControl.ReferenceColumn].value = searchControl.Default.split(",").map((value) => {
                            return value.trim();
                        });
                        this._useInitialSearchValues = true;
                        break;
                    case SearchControlType.SearchField:
                        this._searchComponents[searchControl.ReferenceColumn].value = searchControl.Default.split(",").map((value) => {
                            return {
                                value: value.trim(),
                                text: value.trim()
                            }
                        });
                        this._useInitialSearchValues = true;
                        break;
                    case SearchControlType.Date:
                        regEx = new RegExp(/\d{4}-(0[1-9]|1[0-2])-(0[1-9]|1[1-9]|2[1-9]|3[01])/);
                        if (this._searchComponents[searchControl.ReferenceColumn].control.IsRange) {
                            const values = searchControl.Default.split(",");
                            if (values.length > 0 && regEx.test(values[0])) {
                                this._searchComponents[searchControl.ReferenceColumn].value = values[0].trim() + "T00:00:00";
                                this._useInitialSearchValues = true;
                            }
                            if (Helper.isNullOrEmpty(this._searchComponents[searchControl.ReferenceColumn].rangeEndValue.toString()) && values.length > 1 && regEx.test(values[1])) {
                                this._searchComponents[searchControl.ReferenceColumn].rangeEndValue = values[1].trim() + "T00:00:00";
                                this._useInitialSearchValues = true;
                            }
                        } else if (regEx.test(searchControl.Default)) {
                            this._searchComponents[searchControl.ReferenceColumn].value = searchControl.Default + "T00:00:00";
                            this._useInitialSearchValues = true;
                        } else if (searchControl.Default.includes("{today}")) {
                            this._searchComponents[searchControl.ReferenceColumn].value = new Date().toISOString();
                        }
                        break;
                    case SearchControlType.DateTime:
                        regEx = new RegExp(/\d{4}-(0[1-9]|1[0-2])-(0[1-9]|1[1-9]|2[1-9]|3[01])T([01][1-9]|2[0-3]):([0-5][0-9]):([0-5][0-9])/);
                        if (this._searchComponents[searchControl.ReferenceColumn].control.IsRange) {
                            const values = searchControl.Default.split(",");
                            if (values.length > 0 && regEx.test(values[0])) {
                                this._searchComponents[searchControl.ReferenceColumn].value = values[0].trim();
                                this._useInitialSearchValues = true;
                            }
                            if (Helper.isNullOrEmpty(this._searchComponents[searchControl.ReferenceColumn].rangeEndValue.toString()) && values.length > 1 && regEx.test(values[1])) {
                                this._searchComponents[searchControl.ReferenceColumn].rangeEndValue = values[1].trim();
                                this._useInitialSearchValues = true;
                            }
                        } else if (regEx.test(searchControl.Default)) {
                            this._searchComponents[searchControl.ReferenceColumn].value = searchControl.Default;
                            this._useInitialSearchValues = true;
                        }
                        break;

                }
            }

            //if the control has a static data source, add it to the data source hash
            if (searchControl.StaticDataSource && Array.isArray(this.props.config.DataSources)) {
                const dsIdx = Helper.findObjIndex(this.props.config.DataSources, "Name", searchControl.StaticDataSource);
                if (dsIdx >= 0) {
                    this._dataSources[searchControl.ReferenceColumn] = this.props.config.DataSources[dsIdx].Items;
                }
            }
        });

        if (!Helper.isObjectEmpty(this.props.queryParameters) && Helper.hasValue(this.props.queryParameters[this._freeTextSearch])) {
            this._searchComponents[this._freeTextSearch] = {
                rangeEndValue: "",
                value: this.props.queryParameters[this._freeTextSearch],
                control: {
                    DisplayName: this.props.translations["Suche.FreeTextSearch"],
                    ReferenceColumn: this._freeTextSearch,
                    Constraint: null,
                    IsRange: false,
                    MultiSelectMode: false,
                    Type: 1,
                    DataSourceUrl: null,
                    Date: null,
                    LookupTableName: null,
                    SearchTextField: null,
                    SearchValueField: null,
                    SearchWindowUrl: null,
                    StaticDataSource: null,
                    UrlTextField: null,
                    UrlValueField: null
                }
            };
            this._useInitialSearchValues = true;
        }
    }

    //triggered on the <input /> change event
    private _handleQuickSearchValueChanged = (value: string) => {
        if ((value.indexOf("{") > -1) || (value.indexOf("}") > -1)) {
            NotificationHelper.showWarningMessage("Looped bracket are not supported");
            value = value.replace("{", "").replace("}", "");
        }
        //update the value
        this._quickSearchState.value = value;
        //prevent the HTTP request
        clearTimeout(this._quickSearchState.timeoutHandle);
        //update the <input /> with the nu value
        this._quickSearchInputRef.setState({
            value: this._quickSearchState.value,
            disabled: false
        });

        //(re)add the timeout
        this._quickSearchState.timeoutHandle = setTimeout(() => {
            //explicit request => do not block data request
            this._cancelDataRequest = false;
            //reset the URL
            if (!this.isWindow) {
                this._updateUrl(true, Helper.hasValue(this._quickSearchState.value) && this._quickSearchState.value !== "" ? false : true);
            }
            //request the data for the first page
            this.cancelDataFetch();
            this._gridDataSource.page(1);
        }, 1000);
    }

    //gets the values of the filter controls
    private _getSearchFilter = (): Array<SearchFilterItem> => {
        const result: Array<SearchFilterItem> = [];

        for (let refCol in this._searchComponents) {
            const sc = this._searchComponents[refCol];
            let item: SearchFilterItem = {
                ReferenceColumn: refCol,
                Text: sc.value,
                Type: this._getServerSearchType(sc.control),
                Additional: Helper.hasValue(sc.control.Constraint) ? sc.control.Constraint : null
            };
            let endRangeItem: SearchFilterItem = null;

            if (sc.control.Type === SearchControlType.Date) {
                //if the control is a date range, add an entry for both "start" and "end" values
                if (sc.control.IsRange) {
                    item.Additional = ">=";
                    item.Text = kendo.toString(sc.value, "d");
                    endRangeItem = {
                        Additional: "<=",
                        ReferenceColumn: item.ReferenceColumn,
                        Text: kendo.toString(sc.rangeEndValue, "d"),
                        Type: item.Type
                    }
                } else {
                    item.Text = kendo.toString(sc.value, "d");
                }
            } else if (sc.control.Type === SearchControlType.DateTime) {
                //if the control is a datetime range, add an entry for both "start" and "end" values
                if (sc.control.IsRange) {
                    item.Additional = ">=";
                    item.Text = kendo.toString(sc.value, "G");
                    endRangeItem = {
                        Additional: "<=",
                        ReferenceColumn: item.ReferenceColumn,
                        Text: kendo.toString(sc.rangeEndValue, "G"),
                        Type: item.Type
                    }
                } else {
                    item.Text = kendo.toString(sc.value, "G");
                }
            } else if (sc.control.Type === SearchControlType.MultiSelect) {
                item.Text = null;
                //multiselect values are sent as a comma-separated string
                if (Array.isArray(sc.value)) {
                    item.Text = sc.value.join("||");
                }
            } else if (sc.control.Type === SearchControlType.SearchField && sc.control.MultiSelectMode) {
                item.Text = '';
                if (Array.isArray(sc.value)) {
                    item.Text = sc.value.map(x => x.value).join("||");
                }
            } else if (sc.control.Type === SearchControlType.Text || sc.control.Type === SearchControlType.SearchField) {

                item.Type = Helper.getValueOrDefault(sc.comparativeOperator, 0);
            }

            //Quick and dirty
            if (Array.isArray((item.Text as any))) {
                item.Text = '';
            }


            result.push(item);
            if (endRangeItem) {
                result.push(endRangeItem);
            }
        }
        return result;
    }

    private _isStaticDataSouceBoolType = (dataSourceName: string) => {
        if (dataSourceName && Array.isArray(this.props.config.DataSources)) {
            for (let i = 0; i < this.props.config.DataSources.length; i++) {
                if (this.props.config.DataSources[i].Name === dataSourceName && this.props.config.DataSources[i].Type === 1) {
                    return true;
                }
            }
        }
        return false;
    }

    //map to the "DynamicQuery" search type => TODO check
    private _getServerSearchType = (control: DynamicSearchControl) => {
        switch (control.Type) {
            case SearchControlType.DropDown:
                if (control.StaticDataSource && this._isStaticDataSouceBoolType(control.StaticDataSource)) {
                    return 3;
                }
                return 1;
            case SearchControlType.MultiSelect:
                return 4;
            case SearchControlType.Date:
                return 2;
            case SearchControlType.DateTime:
                return 5;
            case SearchControlType.CheckBox:
                return 3;
            case SearchControlType.SearchField:
                if (control.MultiSelectMode)
                    return 4;
                else
                    return 0;
            case SearchControlType.Text:
            default:
                return 0;
        }
    }

    //updates the value of a filter control
    private _handleSearchControlChange = (refColumn: string, value: any, isRangeEnd: boolean) => {
        let finalValue = value;

        const sc = this._searchComponents[refColumn];
        if (isRangeEnd) {
            //if date/time range -> set the "end range" value ("start range" will be set in the "default" else branch)
            sc.rangeEndValue = finalValue;
        } else if (sc.control.Type === SearchControlType.MultiSelect) {
            //if the control is MultiSelect, (re)add all the items (does not delete/change the reference to sc.value)
            if (!Array.isArray(sc.value)) {
                sc.value = [];
            }
            sc.value.length = 0;
            value.forEach((v) => {
                switch (typeof v) {
                    case 'object':
                        sc.value.push(v['Key']);
                        break;
                    default:
                        sc.value.push(v);
                        break;
                }
            });
        } else if (sc.control.Type === SearchControlType.CheckBox) {
            sc.value = value ? "1" : "";
        } else {
            //no special case or the "start range" value
            sc.value = finalValue;
        }
        //if the url contains search values, ignore them
        this._useInitialSearchValues = false;
        //update the control
        this._filterContainerRef.setState({});
    }

    //set common config properties
    private _setCommonPropValues = (props: BaseComponentProps, refColumn: string, isRangeEnd: boolean) => {
        props.field.model = refColumn;
        props.field.name = this._searchComponents[refColumn].control.DisplayName;
        props.value = isRangeEnd ? this._searchComponents[refColumn].rangeEndValue : this._searchComponents[refColumn].value;
        props.disabled = this._disabledFilters.findIndex(f => f.toLowerCase() == refColumn.toLowerCase()) > -1;
        if (!Helper.hasValue(props.value)) {
            props.value = "";
        }
        props.onChange = (field, value) => {
            this._handleSearchControlChange(refColumn, value, isRangeEnd);
        }
    }

    //creates an <Innosoft.Core.Components.TextBox /> component
    private _getTextBox = (refColumn: string) => {
        const elemProps = ComponentHelper.createFactory().getDefaultTextBoxProps();
        elemProps.field.triggerOnChange = true;
        this._setCommonPropValues(elemProps, refColumn, false);
        return (
            <>
                {this._searchComponents[refColumn].control.ComparativeActive && !this._searchComponents[refColumn].control.MultiSelectMode ? this._getResrictionDropDown(refColumn) : null}
                <TextBox {...elemProps} />
            </>
        );
    }

    private _getResrictionDropDown = (refColumn: string) => {
        const props = ComponentHelper.createFactory().getDefaultDropDownProps();
        const col = this._searchComponents[refColumn];
        props.dataSource = [
            {
                key: 0,
                value: Helper.getTranslation("WebSMS.DynamicSearch.Comparative.Like")
            },
            {
                key: 6,
                value: Helper.getTranslation("WebSMS.DynamicSearch.Comparative.StartsWith")
            },
            {
                key: 7,
                value: Helper.getTranslation("WebSMS.DynamicSearch.Comparative.EndsWith")
            },
            {
                key: 8,
                value: Helper.getTranslation("WebSMS.DynamicSearch.Comparative.EqualsTo")
            },
        ];
        props.field.dataTextField = "value";
        props.field.dataValueField = "key";
        props.field.optionLabel = "";
        props.disabled = this._disabledFilters.findIndex(f => f.toLowerCase() == refColumn.toLowerCase()) > -1;
        props.value = Helper.getValueOrDefault(col.comparativeOperator, 0);
        props.onChange = (_, value) => {
            this._searchComponents[refColumn].comparativeOperator = value;
        }
        return (
            <>
                <DropDownList {...props} />
            </>
        );
    }

    //creates an <Innosoft.Core.Components.DropDownList /> component
    private _getDropDown = (refColumn: string) => {

        const elemProps = ComponentHelper.createFactory().getDefaultDropDownProps();
        this._setCommonPropValues(elemProps, refColumn, false);
        const searchControl = this._searchComponents[refColumn].control;
        //depending on the type of data source used, set the text/value properties
        if (searchControl.DataSourceUrl) {
            elemProps.field.dataTextField = searchControl.UrlTextField;
            elemProps.field.dataValueField = searchControl.UrlValueField;
        } else if (searchControl.StaticDataSource) {
            elemProps.field.dataTextField = "Text";
            elemProps.field.dataValueField = "Value";
        } else {
            elemProps.field.dataTextField = "Value";
            elemProps.field.dataValueField = "Key";
        }

        //if the data souce is static or has already been loaded, use it (prevents a new HTTP request on every "setState({})")
        if (this._dataSources[refColumn]) {
            elemProps.dataSource = this._dataSources[refColumn];
        } else if (searchControl.DataSourceUrl) {
            elemProps.field.dataSourceUrl = searchControl.DataSourceUrl;
        } else {
            elemProps.field.dataSourceUrl = `DynamicSearch/GetValuesForTable?queryname=${encodeURIComponent(searchControl.LookupTableName)}&searchType=${this.props.searchType}`;
        }

        //cache the data source
        elemProps.onDataLoaded = (field, data) => {
            this._dataSources[refColumn] = data;
        };
        //TODO remove?
        elemProps.field.template = null;
        elemProps.field.listWidth = null;

        return <DropDownList {...elemProps} />;
    }

    //creates an <Innosoft.Core.Components.DatePicker /> component
    private _getDatePicker = (refColumn: string, isRangeEnd: boolean) => {
        const elemProps = ComponentHelper.createFactory().getDefaultDatePickerProps();
        this._setCommonPropValues(elemProps, refColumn, isRangeEnd);

        return <DatePicker {...elemProps} />;
    }

    //creates an <Innosoft.Core.Components.DateTimePicker /> component
    private _getDateTimePicker = (refColumn: string, isRangeEnd: boolean) => {
        const elemProps = ComponentHelper.createFactory().getDefaultDateTimePickerProps();
        this._setCommonPropValues(elemProps, refColumn, isRangeEnd);

        return <DateTimePicker {...elemProps} />;
    }

    //creates an <Innosoft.Core.Components.MultiSelect /> component
    private _getMultiSelect = (refColumn: string) => {
        const elemProps = ComponentHelper.createFactory().getDefaultMultiSelectProps();
        this._setCommonPropValues(elemProps, refColumn, false);
        const searchControl = this._searchComponents[refColumn].control;

        //depending on the type of data source used, set the text/value properties
        if (searchControl.DataSourceUrl) {
            elemProps.field.dataTextField = searchControl.UrlTextField;
            elemProps.field.dataValueField = searchControl.UrlValueField;
        } else if (searchControl.StaticDataSource) {
            elemProps.field.dataTextField = "Text";
            elemProps.field.dataValueField = "Value";
        } else {
            elemProps.field.dataTextField = "Value";
            elemProps.field.dataValueField = "Key";
        }


        //if the data souce is static or has already been loaded, use it (prevents a new HTTP request on every "setState({})")
        if (this._dataSources[refColumn]) {
            elemProps.dataSource = this._dataSources[refColumn];
        } else if (searchControl.DataSourceUrl) {
            elemProps.field.dataSourceUrl = searchControl.DataSourceUrl;
        } else {
            elemProps.field.dataSourceUrl = `DynamicSearch/GetValuesForTable?queryname=${encodeURIComponent(searchControl.LookupTableName)}&searchType=${this.props.searchType}`;
        }
        let setValuesAfterLoading = false;
        if (!Helper.isNullOrEmpty(searchControl.DataSourceTemplate)) {
            elemProps.field.template = searchControl.DataSourceTemplate;
            const dataSource = this._dataSources[refColumn];
            if (Helper.hasValue(dataSource)) {
                const values = dataSource.filter(dsItem => (this._searchComponents[refColumn].value as []).findIndex(value => value == dsItem.Key) != -1)
                elemProps.value = values;
            } else {
                elemProps.value = [];
            }

            if (Helper.hasValue(searchControl.ListWidth))
                elemProps.field.listWidth = searchControl.ListWidth;

            setValuesAfterLoading = true;
        } else {
            //use primitive values in the value (easier to send/store/load values)
            elemProps.field.primitiveValue = true;
        }
        elemProps.field.searchFilter = searchControl.SearchFilter;

        //cache the data source
        elemProps.onDataLoaded = (_, data) => {
            this._dataSources[refColumn] = data;
            if (setValuesAfterLoading) {
                const values = data.filter(dsItem => (this._searchComponents[refColumn].value as []).findIndex(value => value == dsItem.Key) != -1);
                this._handleSearchControlChange(refColumn, values, false);
                this.setState({})
            }
        };


        return <MultiSelect {...elemProps} />;
    }

    private _getSearchField = (refColumn: string) => {
        const elemProps = ComponentHelper.createFactory().getDefaultSearchFieldProps();
        this._setCommonPropValues(elemProps, refColumn, false);
        const searchControl = this._searchComponents[refColumn].control;
        elemProps.field.searchWindowUrl = searchControl.SearchWindowUrl;
        if (searchControl.MultiSelectMode) {
            elemProps.field.searchTextField = searchControl.SearchTextField;
            elemProps.field.searchValueField = searchControl.SearchValueField;
            elemProps.multiSelectMode = true;
            elemProps.onChange = (field: { model: string }, value: any, dataItem?: any) => {
                this._handleSearchControlChange(refColumn, value, false);
            }
        }
        return (
            <>
                {this._searchComponents[refColumn].control.ComparativeActive ? this._getResrictionDropDown(refColumn) : null}
                <IsSearchField {...elemProps} />
            </>
        );

    }

    private _getCheckBox = (refColumn: string) => {
        const elemProps = ComponentHelper.createFactory().getDefaultCheckBoxProps();
        this._setCommonPropValues(elemProps, refColumn, false);
        return <CheckBox {...elemProps} />;
    }

    //adds the common HTML
    private _wrapSearchComponent = (comp, label: string, index: string, isGroup: boolean, wrapperStyle: React.CSSProperties = null, inputWrapperStyle: React.CSSProperties = null) => {
        return (
            <div className={"advanced-search__field-wrapper" + (isGroup ? " groupDiv" : "")} key={index} style={wrapperStyle}>
                <label>{label}</label>
                <div style={inputWrapperStyle}>{comp}</div>
            </div>
        );
    }

    //gets the list of filter control components
    private _renderSearchComponents = () => {
        const items = [];
        let index = 0;
        for (let colRef in this._searchComponents) {
            const sc = this._searchComponents[colRef];
            let component = null;
            let noWrap = false;
            let wrapperStyle: React.CSSProperties = null;
            let inputWrapperStyle: React.CSSProperties = null
            const backgroundColor = this._searchComponents[sc.control.ReferenceColumn].control.BackgroundColor;
            const padding = Helper.isNullOrEmpty(backgroundColor) ? "0px" : "4px";
            const borderLeft = `5px solid ${backgroundColor}`;

            switch (sc.control.Type) {
                case SearchControlType.DropDown:
                    component = this._getDropDown(sc.control.ReferenceColumn);
                    inputWrapperStyle = { marginTop: "10px" };
                    break;
                case SearchControlType.Date:
                    //if the component is a date range, render two date components, with additional structure
                    if (sc.control.IsRange) {
                        const startDate = this._getDatePicker(sc.control.ReferenceColumn, false);
                        const endDate = this._getDatePicker(sc.control.ReferenceColumn, true);
                        component =
                            <div key={++index} style={{ borderLeft: borderLeft, padding: "0 0 0 5px" }}>
                                <fieldset style={{ boxSizing: "border-box", border: "1px solid #dbdbde", margin: "6px", marginLeft: "0px" }} key={++index}>
                                    <legend style={{ display: "block", paddingLeft: "0px" }}>{sc.control.DisplayName}</legend>
                                    {this._wrapSearchComponent(startDate, Config.translations.from, (++index).toString(), true, { marginLeft: "6px", padding: padding })}
                                    {this._wrapSearchComponent(endDate, Config.translations.to, (++index).toString(), true, { marginLeft: "6px", padding: padding })}
                                </fieldset>
                            </div>;
                        noWrap = true;
                    } else {
                        component = this._getDatePicker(sc.control.ReferenceColumn, false);
                        inputWrapperStyle = { marginTop: "10px" };
                    }
                    break;
                case SearchControlType.DateTime:
                    //if the component is a date time range, render two date components, with additional structure
                    if (sc.control.IsRange) {
                        const startDate = this._getDateTimePicker(sc.control.ReferenceColumn, false);
                        const endDate = this._getDateTimePicker(sc.control.ReferenceColumn, true);
                        component =
                            <fieldset style={{ boxSizing: "border-box", border: "1px solid #dbdbde", margin: "6px", marginLeft: "0px", borderLeft: borderLeft }} key={++index}>
                                <legend style={{ display: "block", paddingLeft: "0px" }}>{sc.control.DisplayName}</legend>
                                {this._wrapSearchComponent(startDate, Config.translations.from, (++index).toString(), true, { marginLeft: "6px", padding: padding })}
                                {this._wrapSearchComponent(endDate, Config.translations.to, (++index).toString(), true, { marginLeft: "6px", padding: padding })}
                            </fieldset>;
                        noWrap = true;
                    } else {
                        component = this._getDateTimePicker(sc.control.ReferenceColumn, false);
                        inputWrapperStyle = { marginTop: "10px" };
                    }
                    break;
                case SearchControlType.MultiSelect:
                    //TODO check if already initialized
                    if (!Array.isArray(sc.value)) {
                        sc.value = [];
                    }
                    component = this._getMultiSelect(sc.control.ReferenceColumn);
                    break;
                case SearchControlType.SearchField:
                    component = this._getSearchField(sc.control.ReferenceColumn);
                    inputWrapperStyle = { marginTop: "10px" };
                    break;
                case SearchControlType.CheckBox:
                    component = this._getCheckBox(sc.control.ReferenceColumn);
                    break;
                default:
                    component = this._getTextBox(sc.control.ReferenceColumn);
                    break;
            }

            if (!noWrap) {
                if (Helper.hasValue(backgroundColor)) {
                    wrapperStyle = { padding: padding, borderLeft: borderLeft };
                }
                items.push(this._wrapSearchComponent(component, sc.control.DisplayName, (++index).toString(), false, wrapperStyle, inputWrapperStyle));
            } else {
                items.push(component);
            }
        }

        items.push(this._renderResetButton())

        return items;
    }

    private _renderResetButton = () => {
        const resetFilters = () => {
            Object.keys(this._searchComponents).forEach((key) => {
                switch (this._searchComponents[key].control.Type) {
                    case SearchControlType.DropDown:
                    case SearchControlType.MultiSelect:
                        this._searchComponents[key].value = []
                        break;
                    case SearchControlType.CheckBox:
                        this._searchComponents[key].value = false;
                    case SearchControlType.Date:
                    case SearchControlType.DateTime:
                        this._searchComponents[key].value = "";
                        if (this._searchComponents[key].control.IsRange) {
                            this._searchComponents[key].rangeEndValue = "";
                        }
                        break;
                    default:
                        this._searchComponents[key].value = ""
                        break;
                }
                this._filterContainerRef.setState({}, this.triggerSearch);
            });
        }

        return (
            <div className="advanced-search__reset-button" onClick={resetFilters} key={"ds_reset_filters"}>
                {Helper.getTranslation("Suche.ResetFilters")}
            </div>
        );
    }

    ////////// E N D   A C C O R D I O N //////////


    ////////// S E A R C H   T E M P L A T E S //////////

    private _clearSearchComponents = () => {
        for (let colRef in this._searchComponents) {
            const sc = this._searchComponents[colRef];
            if (sc.control.Type === SearchControlType.MultiSelect) {
                if (!Array.isArray(sc.value)) {
                    sc.value = [];
                }
                sc.value.length = 0;
            } else {
                sc.value = "";
                sc.rangeEndValue = "";
            }
        }
    }

    //updates the filter controls with the values from the search template
    private _searchTemplateChanged = (data: any, triggerSearch: boolean, merge: boolean = false) => {
        function setValue(sc: SearchFilterControl, value: any) {
            if (merge && Helper.hasValue(sc.value) && sc.value != "")
                return;
            sc.value = value;
        }

        function setEndValue(sc: SearchFilterControl, value: any) {
            if (merge && Helper.hasValue(sc.rangeEndValue) && sc.rangeEndValue != "")
                return;
            sc.rangeEndValue = value;
        }

        if (Helper.hasValue(data)) {
            for (let colRef in this._searchComponents) {
                const sc = this._searchComponents[colRef];
                //if the control is a date/time range, look for start and end values
                if (sc.control.IsRange) {
                    if (data[`${sc.control.ReferenceColumn}_start`]) {
                        setValue(sc, data[`${sc.control.ReferenceColumn}_start`]);
                    } else {
                        setValue(sc, "");
                    }
                    if (data[`${sc.control.ReferenceColumn}_end`]) {
                        setEndValue(sc, data[`${sc.control.ReferenceColumn}_end`]);
                    } else {
                        setEndValue(sc, "");
                    }
                } else if (sc.control.Type === SearchControlType.DropDown && Array.isArray(data[colRef])) {
                    setValue(sc, data[colRef][0]);
                } else if (sc.control.Type === SearchControlType.MultiSelect) {
                    const value = data[colRef];
                    if (Helper.hasValue(value) && value !== "" && !Array.isArray(value)) {
                        setValue(sc, [value]);
                    } else {
                        setValue(sc, value);
                    }
                } else {
                    if (Helper.hasValue(data[colRef])) {
                        setValue(sc, data[colRef]);
                    } else {
                        setValue(sc, "");
                    }
                }
            }
            //Default template
            if (!this._accordionOpen && triggerSearch)
                this._filterContainerRef.toggle(true);
        } else {
            //data is null => no template => reset all the values
            this._clearSearchComponents();
        }

        //the filter values have changed, update the controls
        //this._searchComponentsContainerRef.setState({}, () => {
        this._filterContainerRef.setState({}, () => {
            //if auto search is checkd, get the data
            if (triggerSearch) {
                if (!this.isWindow) {
                    this._updateUrl(false, false);
                }
                this.cancelDataFetch();
                this._gridDataSource.page(1);
            }
        });
    }

    //creates a hash with the filter values (used for updating the URL and by the search templates)
    private _filterDataProvider = (): StringKeyDictionary<any> => {
        const result: StringKeyDictionary<any> = {};

        for (let colRef in this._searchComponents) {
            const sc = this._searchComponents[colRef];
            //TODO check again
            if (sc.control.IsRange && Helper.hasValue(sc.rangeEndValue) && sc.rangeEndValue !== "") {
                result[`${colRef}_start`] = sc.value;
                result[`${colRef}_end`] = sc.rangeEndValue;
            } else if (sc.control.Type === SearchControlType.SearchField && sc.control.MultiSelectMode && Array.isArray(sc.value)) {
                result[colRef] = sc.value.map(x => x.value).join("||");
            } else if (Array.isArray(sc.value)) {
                result[colRef] = sc.value.join("||");
            } else if (((sc.control.Type === SearchControlType.Text) || (sc.control.Type === SearchControlType.SearchField)) && Helper.hasValue(sc.comparativeOperator) && sc.comparativeOperator !== 0) {
                result[colRef] = sc.value;
                switch (sc.comparativeOperator) {
                    case 6:
                        result[`${colRef}_comparative`] = "startswith";
                        break;
                    case 7:
                        result[`${colRef}_comparative`] = "endswith";
                        break;
                    case 8:
                        result[`${colRef}_comparative`] = "equalto";
                        break;
                }
            } else {
                result[colRef] = sc.value;
            }
        }

        return result;
    }

    ////////// E N D   S E A R C H   T E M P L A T E S //////////


    ////////// G R I D //////////

    //gets the grid data using a custom data sorce


    private _getLikeQueryString = () => {
        if (!Helper.hasValue(this._quickSearchState.value)
            && this._quickSearchState.value !== ""
            && (this._accordionOpen || this._useInitialSearchValues)
            || Helper.useMobileGui()) {

            const filters = this._getSearchFilter();
            for (let i = 0; i < filters.length; i++) {
            }

            return JSON.stringify(this._getSearchFilter());
        }




        return null;
    }

    private _getGridData = async (dataSource: kendo.data.DataSource, options: kendo.data.DataSourceTransportOptions, exportAll: boolean = false) => {
        let data: StringKeyDictionary<any> = {
            quickSearch: false, //not used?!
            //quick search text is always up to date
            text: this._quickSearchState.value,
            //set the filter values only if the accordion is open or after the page is first loaded (query string values)
            likeQueryString: this._getLikeQueryString(),
            searchType: this.props.searchType,
            take: dataSource.pageSize(),
            skip: 0,
            pageSize: dataSource.pageSize(),
            page: dataSource.page(),
            sort: dataSource.sort(),
            cus_skills: Helper.hasValue(this._requirementProfile) ? this._requirementProfile.getSkillsJSON() : null,
            exportAll: exportAll
        };
        this.findGridData(options, data);
    }

    private lastCancelToken: CancelTokenSource;
    private option;
    private cancelDataFetch = () => {
        if (this.lastCancelToken) {
            this.lastCancelToken.cancel();
            this.option.error("");
            this.lastCancelToken = null;
        }
    }

    private findGridData = async (options, data) => {
        let customSort = {};
        //console.table(JSON.parse(data.likeQueryString));
        //update the sort values to the ASP.NET MVC format
        const additional = this.dynamicSearchCallbacks.onAdditionalData() || {};
        if (Array.isArray(data.sort) && data.sort.length > 0) {
            const mvcSort = `${data.sort[0].field}-${data.sort[0].dir}`;
            //$.extend(data, { sort: mvcSort }, additional);
            customSort = { sort: mvcSort };
        }

        const additionalUrlParameters = {};
        //check and add filter values from the url
        if (Helper.hasValue(this.props.queryParameters)) {
            for (let key in this.props.queryParameters) {
                if (this._searchComponents[key]) {
                    additionalUrlParameters[key] = this.props.queryParameters[key];
                }
            }
        }
        //check and add custom parameters from the url
        if (Helper.hasValue(this.props.customParameters)) {
            for (let key in this.props.customParameters) {
                additionalUrlParameters[key] = this.props.customParameters[key];
            }
        }
        $.extend(data, customSort, additionalUrlParameters, additional);

        //if (this.lastCancelToken) {
        //    this.lastCancelToken.cancel();
        //    this.lastCancelToken = null;
        //}

        const currentToken = axios.CancelToken.source();
        this.lastCancelToken = currentToken;

        this.option = options;
        
        
        HTTPService.requestStart(this._gridElementRef);

        if (this.props.searchType.toLowerCase() == 'resource' && this._requirementProfile) {
            let matrixResult = await this._requirementProfile.getMatrix();
            if (matrixResult != null) {
                data["ressNrsMatrix"] = matrixResult.map(x => x.RessNr);
            }
        }

        axios.post(Config.baseUrl + "DynamicSearch/FindGridData", data, {
            cancelToken: currentToken.token
        }).then((result) => {
            if (this.lastCancelToken == currentToken) {
                if (result.data.Code != 1) {
                    if (this.props.searchType.toLowerCase() == 'resource' && this._requirementProfile) {
                        this._requirementProfile.filterMatrix(result.data.Data.Data.map(x => x.ressnr));
                        this._requirementProfile.setState({});
                    }
                    this.option.success(result.data.Data);
                }
                else {
                    NotificationHelper.showErrorMessage(result.data.Message);
                    this.option.error(result.data.Message);
                }
                HTTPService.requestEnd(this._gridElementRef);
            }
            else
                HTTPService.requestEnd(this._gridElementRef);
        }).catch((err) => {
            HTTPService.requestEnd(this._gridElementRef);
            if (this.lastCancelToken == currentToken) {
                this.option.error("unhandled exception");
            }
        });
    }

    //gets all the data items for the current search
    private _getAllGridDataItems = (onSuccess: (dataItems: Array<any>) => void, exportAll: boolean = false) => {
        const tmpOpt = this._gridDataSource.options;
        //create a new data source for getting all the data
        const tempDataSource = new kendo.data.DataSource({
            transport: {
                read: (options: kendo.data.DataSourceTransportOptions) => {
                    this._getGridData(tempDataSource, options, exportAll);
                }
            },
            //set the page size to the total number of items => only one possible page
            pageSize: this._gridDataSource.total(),
            //get the current sorting settings
            sort: this._gridDataSource.sort(),
            //copy filtering options  (should be "true" for all)
            serverFiltering: tmpOpt.serverFiltering,
            serverPaging: tmpOpt.serverPaging,
            serverSorting: tmpOpt.serverSorting,
            //use the same data schema
            schema: tmpOpt.schema,
        });

        //get the data
        Helper.setBusyIndicator(true).then(_ => {
            tempDataSource.fetch(() => {
                Helper.setBusyIndicator(false).then(_ => {
                    //convert date strings
                    this._convertDateColumns(tempDataSource.data());
                    //process the data
                    onSuccess(this._observableArrayToJSArray(tempDataSource.data()));
                });
            }).fail(() => {
                Helper.setBusyIndicator(false);
                NotificationHelper.showErrorMessage(Config.translations.noConnection);
            });
        });
    }

    //filters the multi items (and returns only the "grid items")
    private _getNonDeletedItems = () => {
        return this._multiSelectItems.filter(item => { return !item.isDeleted; }).map(item => { return item.item; });
    }

    //checks the selected item and updates the summary
    private _addMultiSelectDataItem = (item: any, isDynamic: boolean) => {
        //if the item was marked as "deleted", remove it (it will be added again at the end of the array)
        const idx = this._getMultiSelectItemIndex(item);
        if (idx >= 0) {
            if (this._multiSelectItems[idx].isDeleted) {
                this._multiSelectItems.splice(idx, 1);
            }
        }

        //if the item has not been already selected...
        if (this._getMultiSelectItemIndex(item) === -1) {
            //select the item
            this._multiSelectItems.push({
                isDeleted: false,
                isNew: true,
                item: item,
                dynamicallyAdded: isDynamic
            });
            //run the callback (if defined)
            this.dynamicSearchCallbacks.onMultiRowsSelected(this._getNonDeletedItems());
        }
        //update the summary
        if (this._multiSelectSummaryRef) {
            this._multiSelectSummaryRef.setState({}, () => {
                if (this._gridRef)
                    this._gridRef.clearSelection()
            });
        }
    }

    private _getColumnUrl = (url, colName: string) => {


        if (Helper.hasValue(this.props.config.LinkPrimaryKeyName)) {
            url += `${this.props.config.LinkPrimaryKeyName}=#=encodeURIComponent(${Helper.hasValue(this.props.config.LinkPrimaryKeyColumnName) ? this.props.config.LinkPrimaryKeyColumnName : colName})#`;

            if (Helper.hasValue(this.props.config.LinkAdditionalKeyName)) {
                url += `&${this.props.config.LinkAdditionalKeyName}=#=encodeURIComponent(${this.props.config.LinkAdditionalColumnName})#`;
            }
        } else {
            url += `#=encodeURIComponent(${Helper.hasValue(this.props.config.LinkPrimaryKeyColumnName) ? this.props.config.LinkPrimaryKeyColumnName : colName})#`;
        }

        if (Helper.hasValue(this.props.config.LinkAdditionalParameter)) {
            url += `&${this.props.config.LinkAdditionalParameter}`;
        }
        return url;
    }

    private _getUrl = (url, dataItem: any) => {
        const linkKey = dataItem[this.props.config.WindowLinkElements[0]];
        if (Helper.hasValue(this.props.config.LinkPrimaryKeyName)) {
            const primaryKeyColName = this.props.config.LinkPrimaryKeyColumnName ?? this.props.config.LinkPrimaryKeyName;
            url += `${this.props.config.LinkPrimaryKeyName}=${encodeURIComponent(Helper.hasValue(dataItem[primaryKeyColName]) ? dataItem[primaryKeyColName] : linkKey)}`;

            if (Helper.hasValue(this.props.config.LinkAdditionalKeyName)) {
                const additionalKeyColName = this.props.config.LinkAdditionalColumnName ?? this.props.config.LinkAdditionalKeyName;
                url += `&${this.props.config.LinkAdditionalKeyName}=${encodeURIComponent(dataItem[additionalKeyColName])}`;
            }
        } else {
            url += encodeURIComponent(Helper.hasValue(this.props.config.LinkPrimaryKeyColumnName) ? dataItem[this.props.config.LinkPrimaryKeyColumnName] : linkKey);
        }

        if (Helper.hasValue(this.props.config.LinkAdditionalParameter)) {
            url += `&${this.props.config.LinkAdditionalParameter}`;
        }
        return url;
    }

    private _getSorting = () => {
        const columns = Helper.loadDataFromStorage(ComponentHelper.getKendoGridStorageKey(this._gridKey))
        if (Helper.hasValue(columns)) {
            const item = columns.find(f => !Helper.isNullOrEmpty(f.sort));
            if (Helper.hasValue(item)) {
                return {
                    field: item.name,
                    dir: item.sort
                };
            }
        }
        return null;
    }

    //initializes the grid options (data source, columns, cells, etc.)
    private _initGridOptions = () => {
        //set up the data source
        this._gridDataSource = new kendo.data.DataSource({
            transport: {
                read: (options: kendo.data.DataSourceTransportOptions) => {
                    $(".k-loading-mask", this._gridElementRef).remove();
                    this._getGridData(this._gridDataSource, options);
                }
            },
            serverFiltering: true,
            serverPaging: true,
            serverSorting: true,
            schema: {
                total: "Total",
                data: "Data"
            },
            pageSize: this.options.pageSize,
            error: () => {
                this.dynamicSearchCallbacks.onRequestError();
            },
            requestStart: (e: kendo.data.DataSourceRequestStartEvent) => {
                let validRequest = true;
                if (this.props.config.SearchOnLoad === false && this._cancelDataRequest) {
                    validRequest = false;
                    e.preventDefault();
                }

                if (validRequest) {
                    this.dynamicSearchCallbacks.onRequestStart();
                }
            },
            requestEnd: () => {
                this.dynamicSearchCallbacks.onRequestEnd(this._observableArrayToJSArray(this._gridDataSource.data()));
            },
            change: () => {
                //new page or sort
                this._dataItem = null;
                this.dynamicSearchCallbacks.onRowSelected(null);
                this._menuRef.setState({});
            },
            sort: this._getSorting()
        });

        this._gridOptions.dataSource = this._gridDataSource;
        this._gridOptions.columns = [];

        const hasContextMenu = Object.getOwnPropertyNames(this._contextMenuButtons).length > 0;
        if (hasContextMenu) {
            let contextOptions = "";
            for (var name in this._contextMenuButtons) {
                const mb = this._contextMenuButtons[name];
                contextOptions += `<div data-name="${mb.Name}">${mb.Text}</div>`;
            }
            this._gridOptions.columns.push(
                {
                    template: '<div class="grid-options-column"><i class="fal fa-ellipsis-v fa-2x" aria-hidden="true"></i><div class="grid-row-options">' + contextOptions + '</div></div>',
                    width: !Helper.useMobileGui() ? 20 : "2em",
                    attributes: {
                        style: "overflow:visible",
                        "class": "grid-options-wrapper"
                    },
                    field: "rowoptions",
                    title: " ",
                    sortable: false
                }
            );
        } else if (this.props.config.IsMultiSelect && this.props.config.WindowLinkElements.length > 0 && !this.props.config.OpenActionDisabled && !this._openActionDisabled) {
            const linkKey = this.props.config.WindowLinkElements[0];
            let url = this._getColumnUrl(this._editUrlStem, linkKey);
            this._gridOptions.columns.push(
                {
                    template: `<div title=${this.props.translations["Suche.ShowDetails"]} data-url=${url} class="grid-options-column openEntity" style="cursor: pointer"><i class="fal fa-external-link" aria-hidden="true"></i></div>`,
                    width: 50,
                    field: "open",
                    title: " ",
                    hidden: Helper.useMobileGui()
                }
            );

        }
        if (this.props.config.RowTemplate != null) {
            const tempColName = "_DS_Template";
            let tempStr = this.handlePlaceholder(this.props.config.RowTemplate);
            const column2: kendo.ui.GridColumn = {
                title: " ",
                field: tempColName,
                template: tempStr,
                hidden: !Helper.useMobileGui()
            };
            this._gridOptions.columns.push(column2);

        }
        //init & add the grid columns
        this.props.config.Columns.forEach((colInfo, cIdx) => {
            const colName = colInfo.Name;
            if (this.props.config.HiddenColumns.indexOf(colName) === -1) {
                const column: kendo.ui.GridColumn = {
                    field: colName,
                    title: colInfo.DisplayName,
                    headerTemplate: "<span title='" + colInfo.DisplayName + "' > " + colInfo.DisplayName + "</span>",
                    hidden: Helper.useMobileGui()
                };

                let url = this._getColumnUrl(this._editUrlStem, colName);
                if (this.isWindow) {
                    if (!this.props.config.IsMultiSelect && Array.isArray(this.props.config.WindowLinkElements) && this.props.config.WindowLinkElements.indexOf(colName) !== -1) {
                        column.template = `<a href="${url}" data-grid-link="${colName}" data-grid-selector="true" style="color: \\#173D78" >#=${colName}#</a>`;
                    }
                } else {
                    if (!this.props.config.IsMultiSelect && Array.isArray(this.props.config.WindowLinkElements) && this.props.config.WindowLinkElements.indexOf(colName) !== -1 && !this.props.config.OpenActionDisabled) {
                        column.template = `<a href="${url}" data-grid-link="${colName}" style="color: \\#173D78">#=${colName}#</a>`;
                    }
                }
                switch (colInfo.Type) {
                    case ColumnType.DateTime:
                        let format = "d";
                        if (Helper.hasValue(colInfo.Format) && Helper.hasValue(colInfo.Format.Format) && colInfo.Format.Format !== "") {
                            format = colInfo.Format.Format
                        }
                        column.format = `{0:${format}}`;
                        break;
                    case ColumnType.Boolean:
                        column.template = `# if((data.${colName} != null) &&((data.${colName}.toString().toLocaleLowerCase() === "true")||(data.${colName}.toString().toLocaleLowerCase() === "1"))) {# <div class='grid-icon-custom-center' style='color:green'><i class='fas fa-check'></i></div> #} #`;
                        break;
                    case ColumnType.Image:
                        column.template = (data) => {
                            const id = data[colName];
                            let innerHtml = "<div></div>"
                            if (!Helper.isNullOrEmpty(id)) {
                                innerHtml = `<img data-role="dynamicSearchImage" src="${Config.baseUrl}Thumbnail/Get/${id}"></img><i class="fa-regular fa-spinner spinner"></i>`
                            } else if (this.props.useDefaultImages) {
                                innerHtml = `<img src="${Config.baseUrl}Content/dynamicSearch/${this.props.searchType.toLowerCase()}.png"></img>`
                            } else {
                                innerHtml = `<div>${Config.translations.noImage}</div>`;
                            }
                            return `<div class='gridImage gridImage-loading'>${innerHtml}</div>`;
                        }
                        break;

                }

                if (Helper.hasValue(colInfo.Width)) {
                    column.width = colInfo.Width;
                    column.minResizableWidth = 30;
                }

                if (colInfo.IsBackgroundColor) {
                    column.template = `<div style='width:100%;height:100%;' data-bg-color='#=${colName}#'>&nbsp;</div>`;
                }

                if (!Helper.isNullOrEmpty(colInfo.Template)) {
                    column.template = colInfo.Template;
                }

                this._gridOptions.columns.push(column);
            }
        });
        this._gridOptions.columns = ComponentHelper.getKendoGridColumns(this._gridKey, this._gridOptions.columns);
        //im ComponentHelper gesetzt
        const saveColumnsToLocalStorage = this._gridOptions.columnReorder;
        this._gridOptions.columnReorder = (e) => {
            if (e.column.field === "rowoptions") {
                setTimeout(() => {
                    this._gridRef.reorderColumn(0, e.column);
                }, 0);
            } else if (hasContextMenu && e.newIndex === 0) {
                setTimeout(() => {
                    this._gridRef.reorderColumn(e.oldIndex, e.column);
                }, 0);
            } else {
                saveColumnsToLocalStorage(e);
            }
        }

        this._gridOptions.change = (e) => {
            const item = this._gridRef.dataItem(this._gridRef.select());

            //get the selected data item(s)
            if (this.props.config.IsMultiSelect) {
                if (this._addItemToMultislect) {
                    this._addMultiSelectDataItem(item, false);
                    this.dynamicSearchCallbacks.onRowSelected(item);
                }
            } else {
                this._dataItem = item;
                this.dynamicSearchCallbacks.onRowSelected(this._dataItem);
            }

            //signal selection and enable menu buttons
            this._menuRef.setState({});
        }
        this._gridOptions.dataBinding = (e) => {
            //before each data bound, check and convert date columns
            this._convertDateColumns(this._gridDataSource.data());
        };
        this._gridOptions.dataBound = (e) => {
            //after each data bound, update color options
            this._setColors();
            this._handleImageLoading(e);
            this.dynamicSearchCallbacks.onGridDataBound(this._observableArrayToJSArray(this._gridDataSource.data()));
        }

        if (this.props.config.UseNextForPaging === true) {
            this._gridOptions.pageable = {
                numeric: false,
                info: false
            } as kendo.ui.GridPageable;
        }

    }

    private handlePlaceholder = (rowTemplate: string): string => {
        const placeholder = "{{Link}}";
        const placeholderDefaultImage = "{{DefaultImage}}";

        const linkKey = this.props.config.WindowLinkElements[0];
        let tempUrl = this._getColumnUrl(this._editUrlStem, linkKey);
        let tempStr = rowTemplate;
        if (this.isWindow) {
            if (!this.props.config.IsMultiSelect && Array.isArray(this.props.config.WindowLinkElements) && tempStr.match(placeholder)) {
                tempStr = tempStr.replace(placeholder, `<a href="${tempUrl}" data-grid-link="${linkKey}" data-grid-selector="true">#=${linkKey}#</a>`);
            }
        } else {
            if (!this.props.config.IsMultiSelect && Array.isArray(this.props.config.WindowLinkElements) && tempStr.match(placeholder)) {
                tempStr = tempStr.replace(placeholder, `<a href="${tempUrl}" data-grid-link="${linkKey}">#=${linkKey}#</a>`);
            }
        }

        if (tempStr.match(placeholderDefaultImage)) {
            let innerHtml = `<div>${Config.translations.noImage}</div>`;
            if (this.props.useDefaultImages) {
                innerHtml = `<img src="${Config.baseUrl}Content/dynamicSearch/${this.props.searchType.toLowerCase()}.png"></img>`;
            }
            tempStr = tempStr.replace(placeholderDefaultImage, `<div class='gridImage gridImage-loading'>${innerHtml}</div>`);
        }

        return tempStr;
    }

    //convert string values into Date objects
    private _convertDateColumns = (data) => {
        this.props.config.Columns.forEach((c) => {
            if (c.Type === ColumnType.DateTime) {
                data.forEach((item, index) => {
                    if (this._isoFullRegEx.test(item[c.Name])) {
                        item[c.Name] = kendo.parseDate(item[c.Name]);
                    }
                });
            }
        });
    }

    //create a hash for the row/column/cell background color rules
    private _getSwitchHash = (cases: Array<DynamicSearchColorCase>) => {
        const result: StringKeyDictionary<DynamicSearchColorCase> = {};
        if (Array.isArray(cases)) {
            cases.forEach((c) => {
                result[c.Value] = c;
            });
        }

        return result;
    }

    private _handleImageLoading = (event: kendo.ui.GridDataBoundEvent) => {

        const data = event.sender.dataSource.view();
        for (let i = 0; i < data.length; i++) {
            const img = event.sender.tbody.find(`tr[data-uid='${data[i].uid}'] img[data-role='dynamicSearchImage']`);
            if (Helper.hasValue(img) && Helper.hasValue(img[0])) {
                const removeLoadingIcon = (div: HTMLElement) => {
                    div.classList.remove("gridImage-loading");
                    div.classList.add("gridImage-loaded");
                }
                img.on("load", (event) => {
                    const div = event.target.parentElement;
                    removeLoadingIcon(div);
                });
                img.on("error", (event) => {
                    const div = event.target.parentElement;
                    removeLoadingIcon(div);
                    let innerHtml = "";
                    if (this.props.useDefaultImages) {
                        innerHtml = `<img src="${Config.baseUrl}Content/dynamicSearch/${this.props.searchType.toLowerCase()}.png"></img>`
                    } else {
                        innerHtml = `<div>${Config.translations.noImage}</div>`;
                    }
                    div.innerHTML = innerHtml;
                })
            }
        }

    }

    //update all row/column/cell rules
    private _setColors = () => {
        let indexCorrection = 1;

        //column colors
        this.props.config.Columns.forEach((colInfo, cIdx) => {
            //column can have a different index
            const idx = this.getColumnIndex(colInfo.Name);
            const cellSelector = `td:nth-of-type(${(idx + indexCorrection)})`;//`td:nth-of-type(${(cIdx + indexCorrection)})`;

            if (colInfo.ColorRule) {
                const today = new Date();
                this._gridRef.items().toArray().forEach((row, rIdx) => {
                    const dataItem = this._gridRef.dataItem(row);
                    const compRes = Helper.dates.compareMultiTypeDates(dataItem[colInfo.Name], today, true);
                    if (compRes !== null) {
                        $(cellSelector, row).css("background-color", compRes === 1 ? colInfo.ColorRule.GreaterThan : (compRes === -1 ? colInfo.ColorRule.LessThan : colInfo.ColorRule.EqualTo));
                    }
                });
            }

            if (colInfo.ColorSwitch) {
                const hash = this._getSwitchHash(colInfo.ColorSwitch.Cases);
                this._gridRef.items().toArray().forEach((row, rIdx) => {
                    const dataItem = this._gridRef.dataItem(row);
                    const caseColor = hash[dataItem[colInfo.ColorSwitch.SourceColumn]];
                    if (Helper.hasValue(caseColor)) {
                        $(cellSelector, row).css({ "background-color": caseColor.Color, "color": caseColor.Text });
                    }
                });
            }

            if (colInfo.IsBackgroundColor) {
                this._gridRef.items().toArray().forEach((row, rIdx) => {
                    const $content = $("div", $(cellSelector, row));
                    const color = this._service.convertColor(parseInt($content.attr("data-bg-color"), 10));
                    $content.css({
                        "background-color": color,
                        "border": color === "transparent" ? null : "1px solid lightgray"
                    });
                });
            }
        });

        //row color switches
        if (Array.isArray(this.props.config.ColorSwitches)) {
            for (let i = 0; i < this.props.config.ColorSwitches.length; i++) {
                const cSwitch = this.props.config.ColorSwitches[i];
                if (cSwitch.RowMode === true) {
                    this._gridRef.items().toArray().forEach((row, rIdx) => {
                        const $row = $(row);
                        const dataItem = this._gridRef.dataItem(row);
                        for (let j = 0; j < cSwitch.Cases.length; j++) {
                            if (Helper.hasValue(dataItem[cSwitch.SourceColumn]) && dataItem[cSwitch.SourceColumn].toString() === cSwitch.Cases[j].Value) {
                                $row.css({ "background-color": cSwitch.Cases[j].Color, "color": cSwitch.Cases[j].Text });
                            }
                        }
                    });
                }
            }
        }
    }

    private getColumnIndex = (columnName: string) => {
        let columns: any[] = Helper.loadDataFromStorage(ComponentHelper.getKendoGridStorageKey(this._gridKey));
        let idx = Helper.findObjIndex(columns, "name", columnName);

        if (idx == -1) {
            idx = Helper.findObjIndex(this._gridOptions.columns, "field", columnName);
        }

        return idx;
    }

    //handle link click
    private _onGridLinkClicked = ($elem: JQuery, ev: JQuery.Event) => {
        const $gridRows = $("> .k-grid-container > .k-grid-content > table > tbody > tr[role=row]", this._gridElementRef);
        const $row = $elem.closest($gridRows);
        const dataItem = this._gridRef.dataItem($row);
        const listItemClicked = $((ev as any).currentTarget).hasClass("list-item-click");
        if (this.isWindow && !this.openSheet) {
            if ($elem.attr("data-grid-selector") === "true" || listItemClicked) {
                ev.preventDefault();
                this.dynamicSearchCallbacks.onLinkClicked(dataItem, $row, $elem, ev);
                this._sheetContainer.trigger(SheetEventType.RowClicked, this.props.config.ReturnFullObject ? dataItem : dataItem[this.props.config.WindowLinkElements[0]]);
                this._sheetContainer.hide();
            }
        } else {
            this.dynamicSearchCallbacks.onLinkClicked(dataItem, $row, $elem, ev);

            if (ev.button === 0) {
                ev.preventDefault();
                if (Helper.hasValue($elem.attr("data-grid-link"))) {
                    const url = $elem.attr("href");
                    if (!this.props.config.OpenInNewTab)
                        this._openInNewSheet(url);
                    else
                        Helper.openInNewBrowserTab(url);
                } else if (listItemClicked) {
                    let url = this._getUrl(this._editUrlStem, dataItem);
                    if (this._editUrlStem.endsWith("Download?")) {
                        window.open(url, '_blank');
                    }
                    else {
                        this._openInNewSheet(url);
                    }
                }
            }
        }
    }

    ////////// E N D   G R I D //////////


    ////////// M U L T I S E L E C T //////////

    //set general multi select options
    private _initMultiSelect = () => {
        //should always be the case...
        if (this.isWindow) {
            this._sheetContainer.bind(SheetEventType.Close, () => {
                const toRemove: Array<number> = [];

                //only save if "Apply" was clicked
                if (this._applyTriggered) {
                    this._applyTriggered = false;

                    //remove all "deleted" items and set "new" to "false" 
                    for (let i = 0; i < this._multiSelectItems.length; i++) {
                        if (this._multiSelectItems[i].isDeleted) {
                            toRemove.push(i);
                        } else {
                            this._multiSelectItems[i].isNew = false;
                        }
                    }

                    //signal selection
                    this._triggerItemsSelected();
                } else {
                    //"Apply" was not clicked (Close button or Esc) => do not "persist" selected items
                    // => remove all "new" items and set "delete" to "false"
                    for (let i = 0; i < this._multiSelectItems.length; i++) {
                        if (this._multiSelectItems[i].isNew) {
                            toRemove.push(i);
                        } else {
                            this._multiSelectItems[i].isDeleted = false;
                        }
                    }
                }

                //remove "invalid" items
                for (let i = toRemove.length - 1; i >= 0; i--) {
                    this._multiSelectItems.splice(toRemove[i], 1);
                }

                //update (deleted items)
                this._multiSelectSummaryRef.setState({});
            });

            //load existing data (ex: multi select search)
            let externalDataLoaded = false;
            this._sheetContainer.trigger(SheetEventType.SetSelectedItems, (items: Array<any>) => {
                //don't load twice
                if (!externalDataLoaded) {
                    externalDataLoaded = true;
                    if (Array.isArray(items)) {
                        items.forEach((dataItem) => {
                            //add a uid
                            dataItem.uid = kendo.guid();
                            //add the item to the list
                            this._addMultiSelectDataItem(dataItem, true);
                        });
                    }
                }
            });
        }
    }

    //triggers the selection of multiple items (window or iframe)
    private _triggerItemsSelected = () => {
        if (this.props.isIFrame) {
            //this._modalContainer.trigger("itemsSelected", { data: this._getNonDeletedItems() });
            window.postMessage(JSON.stringify({ data: this._getNonDeletedItems() }), '*');
        } else {
            this._sheetContainer.trigger(SheetEventType.ItemsSelected, { data: this._getNonDeletedItems() });
        }
    }

    //checks if an object has already been added to "this._muliSelectItems" and returns its index in the array
    private _getMultiSelectItemIndex = (item: any): number => {
        for (let i = 0; i < this._multiSelectItems.length; i++) {
            //if the item is "external" (e.g. value item from a multi select search), it has fewer properties
            //since only the properties of the first parameter ar consider, set the "external" item as "source" 
            //and compare only its own properties
            if (this._multiSelectItems[i].dynamicallyAdded) {
                if (this._areObjectPropertiesEqual(this._multiSelectItems[i].item, item, ["uid"])) {
                    return i;
                }
            } else {
                if (this._areObjectPropertiesEqual(item, this._multiSelectItems[i].item, ["uid"])) {
                    return i;
                }
            }
        }

        return -1;
    }

    //handle the selection of the current page of all grid elements
    private _handleBatchDataSelect = (currentPage: boolean) => {
        if (currentPage) {
            //get the local data
            this._gridRef.dataSource.data().forEach(item => {
                this._addMultiSelectDataItem(item, false);
            });

            //run the callback (if defined)
            this.dynamicSearchCallbacks.onMultiRowsSelected(this._getNonDeletedItems());
            //update the summary
            this.forceUpdate();
        } else {
            //get all the grid data
            this._getAllGridDataItems((allItems) => {
                //reset the current cache
                this._multiSelectItems.length = 0;
                //process all the items
                allItems.forEach(item => {
                    this._addMultiSelectDataItem(item, false);
                });
                //update the summary
                this.forceUpdate();
            });
        }
    }

    //clear all selected items
    private _clearAllMultiSelectItems = () => {
        this._multiSelectItems.forEach(item => { item.isDeleted = true; });
        this.forceUpdate();
    }

    //signal "Apply" and close the window (trigger "close" event)
    private _applySelection = () => {
        this._applyTriggered = true;
        if (this.props.isIFrame) {
            this._triggerItemsSelected();
        } else {
            this._sheetContainer.hide();
        }
    }

    ////////// E N D   M U L T I S E L E C T //////////


    ////////// E X P O R T //////////

    //gets the list of columns shown in the grid
    private _getVisibleColumnsData = () => {
        const columns = this._gridRef.columns.filter((c) => {
            const column = this.props.config.Columns.find(f => f.Name == c.field);
            return (c.hidden !== true && Helper.hasValue(column) && column.Type !== ColumnType.Image);
        });
        return {
            columns: columns,
            names: columns.map((c) => {
                return c.field;
            })
        };
    }

    //creates the workbook and adds the data (rows)
    private _createExcelWorkbook = (data) => {
        const cData = this._getVisibleColumnsData();
        //prepare columns
        const columns = [];
        for (let i = 0; i < cData.columns.length; i++) {
            columns.push({ autoWidth: true });
        }

        //add the header
        const rows = [{ cells: [] }];
        for (let i = 0; i < cData.columns.length; i++) {
            rows[0].cells.push({ value: cData.columns[i].title, background: "#7a7a7a", color: "#ffffff" });
        }

        //add the data
        data.forEach((dataItem, index) => {
            const cells = [];
            for (let j = 0; j < cData.names.length; j++) {
                cells.push({ value: dataItem[cData.columns[j].field] });
            }
            rows.push({ cells: cells });
        });

        //creates the sheet
        const sheet: kendo.ooxml.WorkbookSheet = {
            columns: columns,
            title: this.props.searchType,
            rows: rows,
            //make all columns filterable
            filter: {
                from: 0,
                to: cData.columns.length - 1
            },
            frozenColumns: 0,
            //freeze the header row
            frozenRows: 1
        };

        //format Date values and apply color rules
        this._formatExcelCells(sheet, data);

        const workbook = new kendo.ooxml.Workbook({
            sheets: [sheet]
        });

        return {
            workbook: workbook,
            columnData: cData
        };
    }

    //converts Date objects and applies color rules
    private _formatExcelCells = (sheet: kendo.ooxml.WorkbookSheet, data: Array<any>) => {
        //row switches
        if (this.props.config.ColorSwitches) {
            this.props.config.ColorSwitches.filter((sw) => {
                return sw.RowMode;
            }).forEach((sw) => {
                data.forEach((dataItem, dIdx) => {
                    for (let j = 0; j < sw.Cases.length; j++) {
                        if (Helper.hasValue(dataItem[sw.SourceColumn]) && dataItem[sw.SourceColumn].toString() === sw.Cases[j].Value) {
                            sheet.rows[dIdx + 1].cells.forEach((cell, cIdx) => {
                                cell.background = sw.Cases[j].Color;
                                cell.color = sw.Cases[j].Text;
                            });
                        }
                    }
                });
            });
        }

        //colum colors
        const columns = this._getSortedColumns();
        columns.forEach((colInfo, cIdx) => {
            if (colInfo.ColorSwitch) {
                const hash = this._getSwitchHash(colInfo.ColorSwitch.Cases);
                for (let i = 0; i < data.length; i++) {
                    const caseColor = hash[data[i][colInfo.ColorSwitch.SourceColumn]];
                    if (Helper.hasValue(caseColor)) {
                        sheet.rows[i + 1].cells[cIdx].background = caseColor.Color;
                        sheet.rows[i + 1].cells[cIdx].color = caseColor.Text;
                    }
                }
            }

            if (colInfo.ColorRule) {
                const today = new Date();
                today.setHours(0, 0, 0, 0);
                for (let i = 1; i < sheet.rows.length; i++) {
                    const cell = sheet.rows[i].cells[cIdx];
                    const value = cell.value;

                    const compRes = Helper.dates.compareMultiTypeDates(cell.value as Date, today, true);
                    if (compRes !== null) {
                        cell.background = compRes === 1 ? colInfo.ColorRule.GreaterThan : (compRes === -1 ? colInfo.ColorRule.LessThan : colInfo.ColorRule.EqualTo);
                    }
                }
            }

            if (colInfo.IsBackgroundColor) {
                for (let i = 0; i < data.length; i++) {
                    const color = this._service.convertColor(data[i][colInfo.Name]);
                    sheet.rows[i + 1].cells[cIdx].background = color === "transparent" ? "" : color;
                    sheet.rows[i + 1].cells[cIdx].value = "";
                }
            }
        });
    }

    private _getSortedColumns = () => {
        const result = [];
        const columns: { name: string }[] = Helper.loadDataFromStorage(ComponentHelper.getKendoGridStorageKey(this._gridKey));
        if (Helper.hasValue(columns)) {
            for (let i = 0; i < columns.length; i++) {
                const column = this.props.config.Columns.find(col => col.Name == columns[i].name);
                if (Helper.hasValue(column)) {
                    result.push(column)
                }
            }

            return result;
        } else {
            return this.props.config.Columns;
        }

    }

    //called for exporting the current page only
    private _exportCurrentPage = () => {
        this._exportExcelData(this._gridRef.dataSource.data());
    }

    //called for exporting all the data
    private _exportAll = () => {
        this._getAllGridDataItems(dataItems => {
            this._exportExcelData(dataItems);
        }, this.props.config.UseNextForPaging);
    }
    private _exportAllNoLimit = () => {
        this._getAllGridDataItems(dataItems => {
            this._exportExcelData(dataItems);
        }, true);
    }

    //exports (saves) the workbook
    private _exportExcelData = (data) => {
        const workbookData = this._createExcelWorkbook(data);
        kendo.saveAs({ dataURI: workbookData.workbook.toDataURL(), fileName: this.props.searchType + ".xlsx" });
    }

    ////////// E N D   E X P O R T //////////


    ////////// E X T R A //////////

    //called when the user clicks the "back" button (only on states added with "push")

    //converts the columns array to a hash, for easier and faster access
    private _createColumnsHash = () => {
        for (let i = 0; i < this.props.config.Columns.length; i++) {
            this._columnsHash[this.props.config.Columns[i].Name] = this.props.config.Columns[i];
        }
    }

    //create a standard JavaScript Array from a Kendo ObservableArray
    private _observableArrayToJSArray = (data: kendo.data.ObservableArray) => {
        const result = [];

        if (data) {
            for (let i = 0; i < data.length; i++) {
                result.push(data[i]);
            }
        }

        return result;
    }

    //compares objects by looking only at primitive properties and Dates (ignoring functions and objects and assuming that the objects have the same properties)
    private _areObjectPropertiesEqual = (source: object, target: object, ignored?: Array<string>): boolean => {
        if (!Helper.hasValue(source) || !Helper.hasValue(target)) {
            return false;
        } else if (source === target) {
            return true;
        } else {
            const toIgnore = Array.isArray(ignored) ? ignored : [];
            const allProperties = Object.getOwnPropertyNames(source);
            const properties = [];
            const dateProperties = [];
            //filter out function and object properties (and "ignored")
            //date properties are handled separately
            for (let i = 0; i < allProperties.length; i++) {
                const prop = allProperties[i];
                if (typeof source[prop] !== "function" && typeof source[prop] !== "object" && toIgnore.indexOf(prop) === -1) {
                    properties.push(prop);
                } else if (source[prop] instanceof Date || target[prop] instanceof Date) {
                    dateProperties.push(prop);
                }
            }

            for (let i = 0; i < dateProperties.length; i++) {
                const prop = dateProperties[i];
                if (!(source[prop] instanceof Date) || !(target[prop] instanceof Date) || source[prop].getTime() !== target[prop].getTime()) {
                    return false;
                }
            }

            for (let i = 0; i < properties.length; i++) {
                if (source[properties[i]] !== target[properties[i]]) {
                    return false;
                }
            }

            return true;
        }
    }

    private _initContextHooks = () => {
        const internalHook = getInternalSearchContextApps()[this.props.searchType.toLowerCase()];
        const customHook = Config.dynamicSearchContextHooks[this.props.searchType.toLowerCase()];

        if (Helper.hasValue(internalHook)) {
            this._contextHooks.push(internalHook);
        }

        if (Helper.hasValue(customHook) && Helper.hasValue(customHook.hook)) {
            if (customHook.overwrite === true) {
                this._contextHooks.length = 0;
            }
            this._contextHooks.push(customHook.hook);
        }
    }

    private _openInNewSheet = (targetUrl: string) => {
        let url = Helper.addUrlParameter(targetUrl, "isWindow=true");
        let savedData = null;
        let entityChanged = false;

        const sheet = General.Sheet.Manager.createSheetWithUrl(url, null, null, true);
        General.Functions.HistoryState.pushSheetState(sheet, url);

        sheet.bind(SheetEventType.SavedSuccessfully, (data) => {
            entityChanged = true;
            savedData = data
        });
        sheet.bind(SheetEventType.ItemDeleted, data => {
            entityChanged = true;
        });
        sheet.bind(SheetEventType.Close, () => {
            if (this.props.isWindow && Helper.hasValue(savedData)) {
                const dataItem = MappingService.tryMap(this.props.searchType, savedData.entity);
                if (Helper.hasValue(dataItem)) {
                    let canProcess = true;
                    const check = this._sheetContainer.getExternalNewDataCheck();
                    if (check) {
                        if (!check.check(dataItem))
                            canProcess = false;
                    }

                    if (canProcess) {
                        if (this.props.config.IsMultiSelect) {
                            this._addMultiSelectDataItem(dataItem, false);
                        } else {
                            this._sheetContainer.trigger(SheetEventType.RowClicked, this.props.config.ReturnFullObject ? dataItem : dataItem[this.props.config.WindowLinkElements[0]]);
                            this._sheetContainer.hide();
                        }
                    }
                }
            } else if (entityChanged) {
                this._gridDataSource.read();
            }
        });
    }

    //update the page url using the filter (quick or advanced search) values
    private _updateUrl = (forQuickSearch: boolean, empty: boolean) => {
        //always send all the filter values (if quicksearch, then the filter properties must be removed...)
        this._stateIndex = this._service.updateSearchUrl(this._filterDataProvider(), forQuickSearch ? this._quickSearchState.value : null, empty);
    }

    private _hideContextMenu = (e: JQuery.Event) => {
        $(".grid-options-column--active", this._gridElementRef).removeClass("grid-options-column--active");
    }

    private _triggerSearch = () => {
        if (!this.isWindow) {
            //no quick search
            let empty = true;
            const filterData = this._filterDataProvider();
            for (let key in filterData) {
                if (Helper.hasValue(filterData[key]) && filterData[key] !== "") {
                    empty = false;
                    break;
                }
            }
            this._updateUrl(false, empty);
        }
        //explicit request => do not block data request
        this._cancelDataRequest = false;
        //this._gridDataSource.read();
        this.cancelDataFetch();
        this._gridDataSource.page(1);
    }

    private _handleEval = (action: string, prepare?: any) => {
        alert("eval");
    }
    ////////// E N D   E X T R A //////////


    ////////// A P I //////////
    addCustomMenuButtons = (buttons: Array<{ name: string; text: string; enableOnSelect?: boolean }>) => {
        buttons.forEach((b, i) => {
            const btn: MenuEntry = {
                text: b.text,
                onClick: b.name,
                show: b.enableOnSelect ? b.name : true,
                inContext: true
            };

            this._menuButtonsData[b.name] = {
                Name: b.name,
                Text: b.text,
                Url: null,
                Items: [],
                Data: null,
                Type: MenuItemType.Command,
                OpenInSheet: false
            };

            this._menuDataSource.push(btn);
        });
        this._menuRef.setState({});
    }

    getCustomHtmlElement = () => {
        return this._customHtml;
    }

    setPageSize = () => {

    }

    triggerSearch = () => {
        this._triggerSearch();
    }

    private _handleItemRemoved = () => {
        this.forceUpdate();
    }

    ////////// E N D   A P I //////////


    ////////// R E D E R I N G //////////

    private _initSearchComponents = () => {
        let newSearchComponents: StringKeyDictionary<SearchFilterControl> = {};
        newSearchComponents[this._freeTextSearch] = {
            rangeEndValue: "",
            value: this._quickSearchState.value,
            control: {
                DisplayName: this.props.translations["Suche.FreeTextSearch"],
                ReferenceColumn: this._freeTextSearch,
                Constraint: null,
                IsRange: false,
                MultiSelectMode: false,
                Type: 1,
                DataSourceUrl: null,
                Date: null,
                LookupTableName: null,
                SearchTextField: null,
                SearchValueField: null,
                SearchWindowUrl: null,
                StaticDataSource: null,
                UrlTextField: null,
                UrlValueField: null
            }
        };
        const fields = Object.keys(this._searchComponents)
        for (let i = 0; i < fields.length; i++) {
            newSearchComponents[fields[i]] = this._searchComponents[fields[i]];
        }
        this._searchComponents = newSearchComponents;
    }

    private _renderContent() {
        this._initSearchComponents();
        return <FullHeightContainer>
            <MultiSelectSummary pattern={this.props.multiSelectPattern} items={this._multiSelectItems} ref={(r) => this._multiSelectSummaryRef = r} onItemRemoved={this._handleItemRemoved} />
            {
                ReactDOM.createPortal(
                    <SearchFilters
                        ref={(r) => this._filterContainerRef = r}
                        quickSearch={() => {
                            return (
                                <QuickSearchInput onChange={this._handleQuickSearchValueChanged} ref={(r) => this._quickSearchInputRef = r} initValue={this._quickSearchState.value} />
                            );
                        }}
                        advancedSearch={() => {
                            return (
                                <FullHeightContainer style={{ overflowY: "auto", marginTop: "5px" }}>
                                    <div className="advanced-search__fields" onKeyDown={(event) => { if (event.keyCode == 13) { this._doOnMenuSelect("search", MouseButton.Left); } }} style={{ flexShrink: 0 }}>
                                        {this._renderSearchComponents()}
                                    </div>
                                    <SearchTemplates translations={this.props.translations} onTemplateSelected={this._searchTemplateChanged} ref={this._setSearchTemplatesRef}
                                        searchType={this.props.searchType} referenceColumns={this._searchComponents} filterDataProvider={this._filterDataProvider} initialSearchTemplate={this.state.inititalSearchTemplate} />
                                </FullHeightContainer>
                            );
                        }}
                        onAdvancedSearchTriggered={() => this._doOnMenuSelect("search", MouseButton.Left)}
                        afterSearchTypeChanged={this._onSearchTypeChanged}
                        initialSearchFilterState={this.options.initialFilterState}
                        disabledFiltersExist={this._disabledFilters.length > 0}
                    />
                    , this._leftDrawerElement[0])
            }
            <FullHeightContainer classes="grid-wrapper" style={{ minHeight: "300px" }} onRef={(r) => this._gridElementRef = r} id={"dynamicSearch_" + this._id} />

        </FullHeightContainer>
    }
    ////////// E N D   R E D E R I N G //////////

    private _initApp() {
        this._sheetContainer = General.Sheet.Manager.getTopMostSheet();
        this._gridKey = "dynamic-" + this.props.searchType;

        this._sheetContainer.trigger(SheetEventType.AppMounting, this);

        //this._accordionOpen = this.options.initialFilterState === DynamicSearch.InitialSearchFilterState.AdvancedSearch;

        //common is only used for hooks 
        //the "init" function is not called
        this.isWindow = this.props.isWindow && !this.props.isIFrame;
        this.openSheet = !Helper.isNullOrEmpty(this.props.queryParameters["openSheet"]) && (this.props.queryParameters["openSheet"] === "true");

        //if (this.isWindow) {
        //    this._modalContainer = Innosoft.Core.Utils.WindowHelper.getTopVisibleWindow().data("kendoWindow");
        //}
        if (!this.isWindow) {
            //this._stateIndex = this._service.initPageHistoryState();
            //General.Functions.HistoryState.acquireState();
            General.Functions.HistoryState.acquireState();
        }

        this._editUrlStem = `${Config.baseUrl}${this.props.queryParameters.openControllerName || this.props.config.OpenControllerName || this.props.searchType}/${this.props.queryParameters.openActionName || this.props.config.OpenActionName || "Edit"}?`;
        if (!Helper.hasValue(this.props.config.LinkPrimaryKeyName)) {
            this._editUrlStem += "id=";
        }

        this._setNewUrl();


        this._createColumnsHash();

        this._initMenu();
        this._initSearchFilterControls();
        this._initContextHooks();

        if (this._useInitialSearchValues) {
            this.options.initialFilterState = InitialSearchFilterState.AdvancedSearch;
        }
        this._accordionOpen = this.options.initialFilterState === InitialSearchFilterState.AdvancedSearch || this._useInitialSearchValues;

        if (this.props.config.IsMultiSelect) {
            this._initMultiSelect();
        }

        //if the URL contains the quick search value, update the input and use the value to filter the data
        if (Helper.hasValue(this.props.quick) && this.props.quick !== "") {
            this._quickSearchState.value = this.props.quick;
            this._useInitialSearchValues = false;
        }

        //bind "onpopstate"
        //this._handlePopState();

        this._leftDrawerElement = General.Sheet.Manager.getTopMostSheet().elements.getLeftDrawerElementRef();

        if (Helper.useMobileGui()) {
            this._leftDrawerElement = General.Sheet.Manager.getTopMostSheet().elements.getToolbarRef();
        }

        const sheetExternalData = this._sheetContainer.getExternalData();
        if (!sheetExternalData || sheetExternalData.disableTabTitle !== true) {
            this.common.updateBrowserTitle(this._browserTitle);
        }

        if (Helper.hasValue(this.props.queryParameters) && !Helper.isNullOrEmpty(this.props.queryParameters.disabled) && (Object.keys(this.props.queryParameters).length > 1)) {
            this._disabledFilters = this.props.queryParameters.disabled.split(',');
        }

        if (Helper.hasValue(this.props.queryParameters) && !Helper.isNullOrEmpty(this.props.queryParameters.openActionDisabled) && (Object.keys(this.props.queryParameters).length > 1)) {
            this._openActionDisabled = this.props.queryParameters.openActionDisabled == "true";
        }

        if (Helper.hasValue(this.props.queryParameters) && !Helper.isNullOrEmpty(this.props.queryParameters.newButtonEnabled) && (Object.keys(this.props.queryParameters).length > 1)) {
            const newButtonEnabled = this.props.queryParameters.newButtonEnabled == "true";
            if (!newButtonEnabled) {
                this._menuDataSource = this._menuDataSource.filter(m => m.type != "new");
            }

        }
    }

    private _setNewUrl = () => {
        if (Helper.isNullOrEmpty(this.props.config.NewUrl)) {
            this._newUrl = `${Config.baseUrl}${this.props.searchType}/${"New"}`;
        } else {
            let url: string = this.props.config.NewUrl;
            const filters = this._getSearchFilter();
            let parameterAdded = false;
            (this.props.config.NewUrlParameters || []).forEach((param) => {
                let value: string;
                const filter = filters.find(x => x.ReferenceColumn == param);
                if (Helper.hasValue(filter)) {
                    if ((filter.Type != 4) || (!filter.Text.includes(","))) {
                        value = filter.Text;
                    }
                } else {
                    value = (this.props.queryParameters[param] as string);
                }
                if (!Helper.isNullOrEmpty(value)) {
                    if (parameterAdded) {
                        url += `&${param}=${value}`;
                    } else {
                        url += `?${param}=${value}`;
                        parameterAdded = true;
                    }
                }
            })
            this._newUrl = `${Config.baseUrl}${url}`;
            const index = this.props.config.MenuButtons.findIndex(f => f.Type == 0)
            if (index > -1) {
                this.props.config.MenuButtons[index].Url = this._newUrl;
            }
        }
        this._newUrl = Helper.addQueryStringParameters(this._newUrl, this.props.newParameters);
    }

    componentDidMount() {
        this.initInitialSearchTemplate();
        this.initGrid();

        this._sheetContainer.trigger(SheetEventType.AppMounted, this);
        if (this._filterContainerRef.state.showAdvanced) {
            const freeSearchEl = document.querySelector(".advanced-search__field-wrapper input") as HTMLElement;
            freeSearchEl?.focus();
        }
    }

    private initInitialSearchTemplate = () => {
        let initialTemplate = SearchTemplatesHelper.getDefaultTemplate(this.props.searchType);

        if (Helper.hasValue(initialTemplate)) {
            let initalTemplateData = SearchTemplatesHelper.mapPersitedSearchTemplateInstanceToData(initialTemplate);
            this._searchTemplateChanged(initalTemplateData, true, true);
        };

        let initialSearchTemplate: InitialSearchTemplate = {
            initialTemplate: initialTemplate,
            merge: Helper.hasValue(initialTemplate) && this.hasQueryParameters([])
        };
        this.setState({ inititalSearchTemplate: initialSearchTemplate });
    }

    private hasQueryParameters = (blackList: string[]) => {
        var hasSearchParams = false;
        if (Helper.hasValue(this.props.queryParameters)) {
            for (let key in this.props.queryParameters) {
                if (!blackList.includes(key)) {
                    hasSearchParams = true;
                    break;
                }
            }
        }
        return hasSearchParams;
    }

    private initGrid = () => {
        this._gridOptions = ComponentHelper.getKendoGridStandardOptions({ useColumnStateManager: true, id: this._gridKey });
        this._initGridOptions();
        this.createGrid();
    }

    createGrid = () => {
        //build grid
        this._gridRef = $(this._gridElementRef).kendoGrid(this._gridOptions).data("kendoGrid");
        //get kendo links into react
        $(this._gridElementRef).on("click", "a[data-grid-link]", (e) => {
            this._onGridLinkClicked($(e.target), e);
        });

        $(this._gridElementRef).on("click", "div.list-item-click", (e) => {
            if (General.Sheet.Manager.getTopMostSheet() == this._sheetContainer) {
                this._onGridLinkClicked($(e.target), e);
            }
        });

        $(this._gridElementRef).on("click", ".grid-options-wrapper", (e) => {
            e.stopPropagation();
            this._hideContextMenu(null);
            $(e.currentTarget).addClass("grid-options-column--active");
        });

        $(this._gridElementRef).on("mouseup", ".openEntity", (e) => {
            const target = e.target;
            let url = $(target).attr("data-url");
            if (Helper.isNullOrEmpty(url) && Helper.hasValue(target.parentElement)) {
                url = $(target.parentElement).attr("data-url");
            }
            this._addItemToMultislect = false;
            setTimeout(() => {
                if (!Helper.isNullOrEmpty(url)) {
                    Helper.openInNewBrowserTab(url)
                }
                this._gridRef.clearSelection()
                this._addItemToMultislect = true;
            }, 1)

        });

        $(document).on("click", this._hideContextMenu);

        //"mouseup" for all buttons
        $(this._gridElementRef).on("mouseup", ".grid-row-options > div", (e) => {
            e.preventDefault();
            e.stopPropagation();
            e.stopImmediatePropagation();
            const dataItem = this._gridRef.dataItem($(e.target).closest("tr"));

            let mBtn = MouseButton.Unknown;
            if (e.button === 0) {
                mBtn = MouseButton.Left;
            } else if (e.button === 1) {
                mBtn = MouseButton.Middle;
            } else if (e.button === 2) {
                mBtn = MouseButton.Right;
            }
            this._handleContextButtonClick($(e.target).data("name"), mBtn, dataItem);
        });

        //if only "prev" & "next" (no pages) are used for paging, hide the "first page" and "last page" buttons
        if (this.props.config.UseNextForPaging === true) {
            $(".k-pager-last, .k-pager-first", this._gridElementRef).hide();
        }
    }

    componentWillUnmount() {
        $(document).off("click", this._hideContextMenu);
        //TODO: check if html/element/component
        ReactDOM.unmountComponentAtNode(this._customHtml);
    }

    shouldComponentUpdate() {
        //never...
        return false;
    }

    render() {
        return (
            <FullHeightContainer classes={this.isWindow ? "" : "sheet"}
                context={this.props.context.contextType}
                searchType={this.props.searchType}>
                <Menu entries={this._menuDataSource} onSelect={this._doOnMenuSelect} enableMenuItem={this._enableMenuItem} ref={(r) => this._menuRef = r} handleEval={this._handleEval} />
                <PageTitle title={this._pageTitle} />
                <RightDrawerContent metadata={this.props.metadata} dynamicSearchCallbacks={this.dynamicSearchCallbacks} multiSelectItems={this._multiSelectItems} common={this.common} />
                <div className="js-dynamic-search__custom-element" ref={(r) => this._customHtml = r}></div>
                {
                    Helper.hasValue(this.props.config.MaxRows) && this.props.config.MaxRows > 0 ?
                        <TitleText text={this.props.config.MaxRowsTitle} style={{ color: "#333", fontSize: "12px", margin: "5px 0px 5px 10px", fontWeight: "bold" }} />
                        : null
                }
                {
                    this.props.withSkills && !Helper.useMobileGui() ?
                        <RequirementProfile
                            isWindow={this.isWindow}
                            triggerSearch={this.triggerSearch}
                            queryParameters={this.props.queryParameters}
                            ref={(ref) => this._requirementProfile = ref}>
                            {this._renderContent()}
                        </RequirementProfile>
                        : this._renderContent()
                }
                {this.isWindow ? null : < EntityReminders />}
                {this.isWindow ? null : < BookmarkBtn contextType={"search"} additionalData={{ searchType: this.props.searchType }} />}
            </FullHeightContainer>
        );
    }
}

export class RightDrawerContent extends React.Component<
    {
        metadata: Metadata,
        multiSelectItems: any,
        common: AppHelper,
        dynamicSearchCallbacks: DynamicSearchCallbacks
    },
    any> {
    private _rightDrawerContainer: any = null;
    private _dataItem: any = null;

    constructor(props) {
        super(props);
        if (Helper.hasValue(this.props.metadata) && Helper.hasValue(this.props.metadata.additional) && Helper.hasValue(this.props.metadata.additional.objects)) {
            this._rightDrawerContainer = this.props.metadata.rightDrawerContainer;

            if (this._rightDrawerContainer !== null) {
                this.props.dynamicSearchCallbacks.onRowSelected = (dataItem: any) => {
                    this._dataItem = dataItem;
                    this.setState({});
                }
            }
        }
    }

    private _renderRightDrawerComponent = () => {
        if (this._rightDrawerContainer !== null) {
            let entity: Entity = {
                IsNew: true,
                RecordRight: {
                    CanRead: true, CanWrite: true
                },
                IsWatchable: false,
                IsWatched: false
            };

            let dataitem = this._dataItem !== null ? this._dataItem : null;
            if (dataitem != null) {
                entity = $.extend({}, entity, dataitem);
                entity.IsNew = false;
            }

            this.props.common.updateEntity(entity);

            return <RightDrawerContainer
                moduleName={this._rightDrawerContainer.moduleName}
                appName={this._rightDrawerContainer.appName}
                visible={this._rightDrawerContainer.visible}
                width={this._rightDrawerContainer.width}
                customProps={this._rightDrawerContainer.props}
                entity={entity}
                handleEval={this.props.common.evalAction}
                allEntities={this.props.multiSelectItems?.filter(x => x.isDeleted == false).map((i) => i.item)}
                renderAlways={this._rightDrawerContainer.renderAlways}
                multipleComponents={this._rightDrawerContainer.multipleComponents} />

        }

        return null;
    }

    render() {
        return this._renderRightDrawerComponent();
    }
}

export class SearchFilters extends React.Component<SearchFiltersProps, { showAdvanced: boolean }> {
    private timeoutHandle = null;
    private modeChanged: boolean;
    constructor(props) {
        super(props);
        this.state = {
            showAdvanced: this.props.initialSearchFilterState === InitialSearchFilterState.AdvancedSearch
        };
    }

    componentDidMount() {
        this._setEvents();
        this.modeChanged = false;
        this.setState({});
    }

    private _setEvents = () => {
        $(document).keyup((e) => {
            if (!this.props.disabledFiltersExist) {
                if (!Helper.isNullOrEmpty(e.key) && e.key.toLowerCase() === 'm' && e.ctrlKey && !e.shiftKey && !e.altKey) {
                    const currentState = this.state.showAdvanced;
                    this.toggle(!currentState);
                }
            }
            if (!Helper.isNullOrEmpty(e.key) && e.key.toLowerCase() === 'n' && e.ctrlKey && e.altKey && !e.shiftKey) {
                General.Events.trigger(EventType.ShortCut, {
                    alt: true,
                    ctrl: true,
                    key: 'n',
                    shift: false
                });
            }
        });

    }

    toggle = (showAdvanced) => {
        this.modeChanged = true;
        this.setState({ showAdvanced: showAdvanced }, () => {
            this.props.afterSearchTypeChanged(showAdvanced);
        });
    }

    componentDidUpdate() {
        clearTimeout(this.timeoutHandle);
        if (this.modeChanged) {
            this.timeoutHandle = setTimeout(() => {
                if (this.state.showAdvanced) {
                    $(".advanced-search__fields input")[0].focus();
                } else {
                    $("#quickSearch")[0].focus();
                }
                this.modeChanged = false;
            }, 400);
        }
    }

    render() {
        const style: React.CSSProperties = { width: "100%", overflowY: "auto", padding: "10px" };
        const linkStyle: React.CSSProperties = { marginTop: "5px" };

        if (Helper.useMobileGui()) {
            return <div className="quick-search-wrapper">{this.props.quickSearch()}</div>;
        }

        return (
            <div style={{ width: "100%", height: "100%", overflow: "hidden" }}>
                <FullHeightContainer classes={"flex-container--row dynamic-search__filters-container " + (this.state.showAdvanced ? "right-active" : "")} style={{}}>
                    <FullHeightContainer style={style}>
                        <FullHeightContainer>
                            {this.props.quickSearch()}
                        </FullHeightContainer>
                        <a onClick={() => this.toggle(true)} style={linkStyle}>{Config.translations.advanced}</a>
                    </FullHeightContainer>
                    <FullHeightContainer style={style}>
                        <FullHeightContainer>
                            <button className="k-button dynamic-search__button" onClick={() => this.props.onAdvancedSearchTriggered()}>
                                {Helper.getTranslation("Standard.Suche")}
                            </button>
                            {this.props.advancedSearch()}
                        </FullHeightContainer>
                        {this.props.disabledFiltersExist ? null : < a onClick={() => this.toggle(false)} style={linkStyle}>{Config.translations.quick}</a>}
                    </FullHeightContainer>
                </FullHeightContainer>
            </div>
        );
    }
}

enum KeyCodes {
    Space = 32,
    Pos1 = 36,
    Left = 37,
    Up = 38,
    Right = 39,
    Down = 40
}

export class QuickSearchInput extends React.Component<DynamicSearchQuickSearchInputProps, { value: string; disabled: boolean; }> {
    private _eventsSet = false;
    private _inputRef: HTMLInputElement = null;

    constructor(props: DynamicSearchQuickSearchInputProps) {
        super(props);
        this.state = {
            value: props.initValue || "",
            disabled: false
        };
    }

    private _handlePropagation = () => {
        if (Helper.hasValue(this._inputRef) && !this._eventsSet) {
            $(this._inputRef).click((e) => {
                e.stopPropagation();
            });
            $(this._inputRef).keydown((e) => {
                if (e.which || e.which === KeyCodes.Space || (e.which >= KeyCodes.Pos1 && e.which <= KeyCodes.Down)) {
                    e.stopPropagation();
                }
            });
            this._eventsSet = true;
        }
    }

    componentDidMount() {
        this._inputRef.focus();
    }

    render() {

        return (
            <div>
                <label className="quicksearch__textbox">
                    <span className="k-input k-textbox k-input-solid k-input-md k-rounded-md">
                        <input type="text"
                            className="k-input-inner"
                            disabled={this.state.disabled}
                            value={this.state.value}
                            placeholder={Helper.getTranslation("Standard.Suche")}
                            onChange={(e) => this.props.onChange((e.target as HTMLInputElement).value)}
                            ref={(r) => { this._inputRef = r; this._handlePropagation(); }}
                            id="quickSearch"
                        />
                    </span>
                    <div className="quicksearch__icon" ><i className="fal fa-search fa-fw" aria-hidden="true"></i></div>
                </label>
            </div>
        );
    }
}

export class MultiSelectSummary extends React.Component<{ pattern: string; items: Array<SelectedItemData>; onItemRemoved?: () => void }, any> {
    private _regExp = /\[\[(.+?)]]/g;
    private _maxItemsToRender = 80;


    private _removeItem = (target: HTMLElement, item: SelectedItemData) => {
        $(target).animate({ width: 0 }, () => {
            $(target).hide();
            item.isDeleted = true;
            this.props.onItemRemoved && this.props.onItemRemoved();
        });
    }

    private _mapItem = (item: SelectedItemData, index: number) => {
        const dataItem = item.item;

        if (Helper.hasValue(dataItem) && (index < this._maxItemsToRender)) {
            let text = this.props.pattern;
            let p = null;
            while (p = this._regExp.exec(this.props.pattern)) {
                if (dataItem[p[1]] !== null) {
                    text = text.replace(p[0], dataItem[p[1]]);
                } else {
                    text = text.replace(p[0], '');
                }
            }

            return (
                <span className="multi-item-holder" key={dataItem.uid} onClick={(e) => { this._removeItem(e.currentTarget, item) }} data-item-hash={Helper.getHashCode(JSON.stringify(item))}>
                    {text + "  "}
                    <span className="multi-delete-marker">{String.fromCharCode(10007)}</span>
                </span>
            );
        } else {
            return null;
        }
    }

    private _renderRemainingItemsLabel = (total) => {
        if (total > this._maxItemsToRender) {
            return (
                <span className="multi-item-holder">+ {total - this._maxItemsToRender}</span>
            );
        } else {
            return null;
        }
    }

    private deleteAll = () => {
        const elements = document.querySelectorAll(".multi-item-holder");
        for (let i = 0; i < elements.length; i++) {
            const target = elements[i];
            $(target).animate({ width: 0 }, () => {
                $(target).hide();
            });
        }
        for (let i = 0; i < this.props.items.length; i++) {
            this.props.items[i].isDeleted = true;
        }
        this.props.onItemRemoved && this.props.onItemRemoved();
    }


    render() {
        const toRender = this.props.items.filter(item => {
            return !item.isDeleted;
        });

        return (
            <div style={{ display: "flex" }}>
                <div style={{ flexShrink: 0, width: "calc(100% - 40px)" }}>
                    {toRender.map(this._mapItem)}{this._renderRemainingItemsLabel(toRender.length)}
                </div>
                <div className="multi-item-delete" onClick={this.deleteAll} style={{ display: toRender.length == 0 ? "none" : "flex" }}>
                    <div title={Helper.getTranslation("Field.Enum.ExecutionAssignmentCancellingAction.Delete")}>
                        <i className="fa-regular fa-xmark"></i>
                    </div>
                </div>
            </div>
        );
    }
}

//JavaScript types
export enum ColumnType {
    Unknown = 0, Integer = 1, Float = 2, String = 3, DateTime = 4, Boolean = 5, Image = 6
}

//available search controls
export enum SearchControlType {
    Unknown = 0, Text = 1, DropDown = 2, Date = 3, DateTime = 4, MultiSelect = 5, SearchField = 6, CheckBox = 7
}

export enum StaticDataSourceType {
    Custom = 0, InnoBoolRule = 1
}

export enum MenuItemType {
    Standard = 0, Link = 1, Command = 2
}

export enum InitialSearchFilterState {
    QuickSearch = 0, AdvancedSearch = 1
}

interface SearchFilterItem {
    ReferenceColumn: string;
    Text: string;
    Type: number;
    Additional: any;
}

interface SelectedItemData {
    item: any;
    isNew: boolean;
    isDeleted: boolean;
    dynamicallyAdded: boolean;
}

interface SearchFiltersProps {
    quickSearch: () => JSX.Element;
    advancedSearch: () => JSX.Element;
    afterSearchTypeChanged: (isAdvanced: boolean) => void;
    onAdvancedSearchTriggered: () => void;
    initialSearchFilterState: InitialSearchFilterState;
    disabledFiltersExist: boolean;
}
export interface DynamicSearchAppProps {
    useDefaultImages: boolean;
    searchType: string;
    isWindow: boolean;
    title: string;
    metadata: Metadata;
    context: {
        contextType: string;
    };
    multiSelectPattern: string;
    fullObject: boolean;
    translations: StringKeyDictionary<string>;
    config: {
        HiddenColumns: Array<string>;
        MenuButtons: Array<DynamicSearchMenuButton>;
        WindowLinkElements: Array<string>;

        OpenActionDisabled: boolean;
        OpenActionName: string;
        OpenControllerName: string;
        OpenInNewTab: boolean;
        LinkPrimaryKeyName: string;
        LinkPrimaryKeyColumnName: string;
        LinkAdditionalKeyName: string;
        LinkAdditionalColumnName: string;
        LinkAdditionalParameter: string;

        IsMultiSelect: boolean;
        ColorSwitches: Array<DynamicSearchColorSwitch>;
        Columns: Array<DynamicSearchColumnInfo>;
        HiddenColumnsInfo: Array<DynamicSearchColumnInfo>;
        SearchControls: Array<DynamicSearchControl>;
        DataSources: Array<DynamicSearchStaticDataSource>;
        SearchOnLoad: boolean;
        UseNextForPaging: boolean;
        MaxRowsTitle: string;
        MaxRows?: number;
        ReturnFullObject: boolean;
        RowTemplate?: string;
        NewUrl?: string;
        NewUrlParameters?: string[];
    };
    queryParameters: StringKeyDictionary<any>;
    customParameters: StringKeyDictionary<any>;
    newParameters: StringKeyDictionary<any>;
    quick: string;
    isIFrame: boolean;
    withSkills: boolean;
    skillsTranslations: {
        skillProfile: string;
        matrix: string;
        general: string;
    };
}

interface DynamicSearchStaticDataSource {
    Name: string;
    Items: Array<{
        Text: string;
        Value: string;
    }>;
    Type: any;//Innosoft.App.DynamicSearch.StaticDataSourceType;
}

interface DynamicSearchQuickSearchInputProps {
    onChange: (value: string) => void;
    initValue: string;
}

export interface DynamicSearchColorSwitch {
    ColumnName: string;
    RowMode: boolean;
    SourceColumn: string;
    Cases: Array<DynamicSearchColorCase>;
}

interface DynamicSearchColorCase {
    Color: string;
    Text: string;
    Value: string;
}

interface DynamicSearchColumnInfo {
    Name: string;
    DisplayName: string;
    Format?: {
        Format: string;
        FormatType: number;
    };
    ColorRule?: {
        EqualTo: string;
        GreaterThan: string;
        LessThan: string;
    };
    ColorSwitch?: DynamicSearchColorSwitch;
    Width?: number;
    Type: any;//Innosoft.App.DynamicSearch.ColumnType;
    IsBackgroundColor: boolean;
    Template: string;
}

interface DynamicSearchCallbacks {
    onRequestStart: () => void;
    onRequestEnd: (dataItems: Array<any>) => void;
    onRequestError: () => void;
    onAdditionalData: () => StringKeyDictionary<any>;
    onRowSelected: (dataItem: any) => void;
    onMultiRowsSelected: (dataItems: Array<any>) => void;
    onLinkClicked: (dataItem: any, $row: JQuery, $link: JQuery, ev: JQuery.Event) => void;
    onCustomButtonClick: (btnName: string, dataItem: any) => void;
    onGridDataBound: (dataItems: Array<any>) => void;
}

export interface DynamicSearchControl {
    ReferenceColumn: string;
    DisplayName: string;
    LookupTableName: string;
    StaticDataSource: string;
    Date: string | Date;
    Constraint: string;
    IsRange: boolean;
    Type: any;//Innosoft.App.DynamicSearch.SearchControlType;
    DataSourceUrl: string;
    UrlTextField: string;
    UrlValueField: string;
    SearchWindowUrl: string;
    SearchTextField: string;
    SearchValueField: string;
    MultiSelectMode: boolean;
    Default?: string;
    ComparativeActive?: boolean;
    Comparative?: number;
    DataSourceTemplate?: string;
    ListWidth?: number;
    BackgroundColor?: string;
    SearchFilter?: "startswith" | "endwith" | "contains";
}

interface DynamicSearchMenuButton {
    Name: string;
    Text: string;
    Url: string;
    Items: Array<DynamicSearchMenuButton>;
    Data: {
        primaryKey?: string;
        additionalKey?: string;
        [key: string]: any;
    };
    Type: any;//Innosoft.App.DynamicSearch.MenuItemType;
    OpenInSheet: boolean;
}